import React from 'react';
// import { Button, Icon } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
// import { RetryLink } from "apollo-link-retry";
// import {Redirect} from 'react-router-dom';
// import gpl from 'graphql-tag';
import _ from 'lodash';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';
// import './respond';

//utils
import queries from '../../src/utils/queries';

//components
import HomePr1 from './home/homepr1';
import HomePr2 from './home/homepr2';
import AddPr1 from './home/addpr1';
import AddPr2 from './home/addpr2';
import VerPr1 from './home/verpr1';
import VerPr2 from './home/verpr2';

import AsocDocEq1 from './home/asocdoceq1';
import AsocDocEq2 from './home/asocdoceq2';

import CargEst1 from './home/cargest1';
import CargEst2 from './home/cargest2';
// import HomeBitacora1 from './home/homebitacora1';
// import HomeBitacora2 from './home/homebitacora2';

import HomeCar from './home/homecar';
import HomeLab from './home/homelab';
import HomeProg from './home/homeprog';
import HomeUser from './home/user/homeuser';

import HomeConf from './home/homeconf';
import HomeSimu from './home/homesimu';
import HomeAdmin from './home/homeadmin';
import HomeGer from './home/homeger';
import IndEmp1 from './home/indemp1';
import IndEmp2 from './home/indemp2';
import BitaEmp1 from './home/bitaemp1';
import BitaEmp2 from './home/bitaemp2';
// import Estilos from '../css/main.css';
import '../css/marquee.css';

//maneja los reintentos por errores de red => proporciona un retroceso exponencial
//y el jitter demora entre los intentos por defecto
//como se maneja ?
// const link = new RetryLink({
//   delay: {
//     initial: 300,
//     max: Infinity,
//     jitter: true
//   },
//   attempts: {
//     max: 5,
//     retryIf: (error, _operation) => !!error
//   }
// });

function getNumDiasMes(mesDias, agnoDias){
  /*
      Los meses 1,3,5,7,8,10,12 siempre tienen 31 días
      Los meses 4,6,9,11 siempre tienen 30 días
      El mes de febrero dependiendo del año puede tener 28 o 29 días
  */
  let mes = parseInt(mesDias, 10)
  let agno = parseInt(agnoDias, 10)

  if( (mes === 1) || (mes === 3) || (mes === 5) || (mes === 7) || (mes === 8) || (mes === 10) || (mes === 12) ) 
    return 31;
  else if( (mes === 4) || (mes === 6) || (mes === 9) || (mes === 11) ) 
    return 30;
  else if( mes === 2 )
  {
      if((agno % 4 === 0) && ((agno % 100 !== 0) || (agno % 400 === 0)))
        return 29;
      else
        return 28;
  }   
}

const styles ={
  modal:{
    width: '40%',
    top: '40%',
    left: '30%',
    position: 'fixed',
    color: 'black'
  },
  bordes:{
    margin: '1em 0em 0.1em 0em',
    padding: '0em 0em 0em 0em',
  },
  menuPpal:{
    width: '20%',
    textAlign: 'Center',
    padding: '0.4em 0.2em 0em 2em',
  },
  boxIzq:{
    width: '20%',
    padding: '0.1em 0.2em 0em 1.2em',
  },
  boxDer:{
    width: '80%',
    padding: '0.1em 1.2em 0em 0.2em',
  },
  boxUnaCol:{
    width: '100%',
    padding: '1em 1em 2em 1em',
  },
  botones:{
    // background: 'linear-gradient(#093028, #237A57)',
    background: '#FE0000',
    margin: '0px 0px 0px 10px',
  },
  menu:{
    background: 'linear-gradient(#FE0000, #FE0000)',
    // background: 'linear-gradient(#FF0000, #dd1818)',
    // background: 'linear-gradient(#355C7D, #6C5B7B)',
  },
  divider:{
    margin: '10px 10px 10px 10px',
  },
  rowMarquee:{
    background: 'linear-gradient(#FEC500, #FEC500)',
    // background: '#0B486B',
    border: 'px solid red',
    margin: '0px',
    padding: '2px 0 0 0',
    color: "black",
    width: '50%',
  },
  titBuscar:{
    background: 'linear-gradient(#FE0000, #FE0000)',
    height: '3em',
    color: 'white',
  },
  titLabel:{
    background: 'linear-gradient(#FE0000, #FE0000)',
    height: 'em',
    // textVAlign: 'center',
    color: 'white',
  },
  titLabel2:{
    background: 'linear-gradient(#FEC500, #f2f792 10%, #FEC500)',
    // height: '2em',
    color: 'black',
  },
  titBuscarTot:{
    fontSize: 16
  },
  etiqClientes:{
    padding: '12px 40px 12px 12px',
    color: "black",
  },
  dropdown:{
    // background: 'linear-gradient(#0F2027, #2C5364)',
    background: 'linear-gradient(#FEC500, #FEC500)',
    // background: 'linear-gradient(#141E30, #243B55)',
    // background: 'linear-gradient(#11998e, #38ef7d)',
    color: 'black',
    textAlign: 'left',
    width: '100%',
    fontWeight: 'bolt',
  },
  listaDer:{
    background: 'linear-gradient(#FEC500, #FEC500)',
    margin: '0px',
    padding: '0px',
    height: '3em',
  },
  detCliente:{
    // background: 'linear-gradient(#1CB5E0, #000046)',
    background: 'linear-gradient(#FEC500, #FEC500)',
    margin: '0px',
    padding: '0px',
    height: '10em',
  },
  detalle:{
    margin: '0px',
    padding: '0px',
  },
  titClientes:{
    background: 'linear-gradient(black, black)',
    height: 'em',
  },
  box:{
    background: 'linear-gradient(#FEC500, #FEC500)', border: '1px solid #FEC500',
    marginBottom: '1em',
    padding: '1em'
  },
  boxGrid:{
    width: '50%'
  },
  elemLis_1:{
    color: '#FE0000',
    fontWeight: 'bold',
  },
  elemLis_2:{
    color: '#FEC500',
    // color: '#2C7744',
    fontWeight: 'bold',
  },
  elemLis_3:{
    color: '#FE0000',
    fontWeight: 'bold',
  },
  subElemLis_1:{
    color: '#FEC500',
    fontWeight: 'bold',
  },
  botIcon:{
    height: '1em',
    width: '1em',
  },
  chekBox:{
    padding: '0em 2em 0em 0em',
    // width: '1em',
  },
  label:{
    color: 'black',
  },
  input:{
    background: 'linear-gradient(#FEC500, #f2f792 10%, #FEC500)',
    border: '1px',
    color: 'black',
    height: '2.9em'
  },
  confirmar:{
    background: 'linear-gradient(#FEC500, #f2f792 10%, #FEC500)',
    border: '0px',
    color: '#135058',
    fontWeight: 'bold',
  },
  styTableSup:{
    margin: '0.2em',
    background: 'linear-gradient(white, white)',
    color: 'black',
    position: 'sticky',
    top: 0,
  },
  styTableInf:{
    margin: '0.1em',
    background: 'linear-gradient(black, black)',
    color: 'black',
  },
  backGr_1:{
    // background: 'linear-gradient(#6dd5ed, #2193b0)',
    background: 'linear-gradient(white, white)',

  },
  backGr_2:{
    background: 'linear-gradient(white, white)',

  },
  styPaddMarg:{
    padding: '0.2em 0.1em 0.2em 0.1em',
    fontSize: '0.9em'
  },
  styInput:{
    width: '8em',
  },
  paraH1:{
    padding: '0em',
    margin: '0em',
    color: 'black',
  },
  paraH2_01:{
    padding: '0em',
    margin: '0em',
    color: 'black',
  },
  paraH2_02:{
      padding: '0em',
      margin: '0em',
      color: 'black',
  },
  thead: {
    position: 'sticky',
    top: 0,
  }
}

//NUMERO A LETRAS
function unidadesNum(num){
  switch(num){
    case 1: return "UN";
    case 2: return "DOS";
    case 3: return "TRES";
    case 4: return "CUATRO";
    case 5: return "CINCO";
    case 6: return "SEIS";
    case 7: return "SIETE";
    case 8: return "OCHO";
    case 9: return "NUEVE";
    default: return "";
  }
  //ojo se comento por sugerencia de react
  // return "";
}//unidadesNum()

function decenasNum(num){
  let decena = Math.floor(num/10);
  let unidad = num - (decena * 10);

  switch(decena){
      case 1:
          switch(unidad){
              case 0: return "DIEZ";
              case 1: return "ONCE";
              case 2: return "DOCE";
              case 3: return "TRECE";
              case 4: return "CATORCE";
              case 5: return "QUINCE";
              default: return "DIECI" + unidadesNum(unidad);
          }
      case 2:
          switch(unidad)
          {
              case 0: return "VEINTE";
              default: return "VEINTI" + unidadesNum(unidad);
          }
      case 3: return decenasYNum("TREINTA", unidad);
      case 4: return decenasYNum("CUARENTA", unidad);
      case 5: return decenasYNum("CINCUENTA", unidad);
      case 6: return decenasYNum("SESENTA", unidad);
      case 7: return decenasYNum("SETENTA", unidad);
      case 8: return decenasYNum("OCHENTA", unidad);
      case 9: return decenasYNum("NOVENTA", unidad);
      case 0: return unidadesNum(unidad);
      default: return "";
  }
}//unidadesNum()

function decenasYNum(strSin, numUnidades) {
  if (numUnidades > 0)
  return strSin + " Y " + unidadesNum(numUnidades)

  return strSin;
}//decenasYNum()

function centenasNum(num) {
  let centenas = Math.floor(num / 100);
  let decenas = num - (centenas * 100);

  switch(centenas)
  {
      case 1:
          if (decenas > 0)
              return "CIENTO " + decenasNum(decenas);
          return "CIEN";
      case 2: return "DOSCIENTOS " + decenasNum(decenas);
      case 3: return "TRESCIENTOS " + decenasNum(decenas);
      case 4: return "CUATROCIENTOS " + decenasNum(decenas);
      case 5: return "QUINIENTOS " + decenasNum(decenas);
      case 6: return "SEISCIENTOS " + decenasNum(decenas);
      case 7: return "SETECIENTOS " + decenasNum(decenas);
      case 8: return "OCHOCIENTOS " + decenasNum(decenas);
      case 9: return "NOVECIENTOS " + decenasNum(decenas);
      default: return "";
  }
//ojo se comento por sugerencia de react
  // return decenasNum(decenas);
}//centenasNum()

function seccionNum(num, divisor, strSingular, strPlural) {
  let cientos = Math.floor(num / divisor)
  let resto = num - (cientos * divisor)

  let letras = "";

  if (cientos > 0)
      if (cientos > 1)
          letras = centenasNum(cientos) + " " + strPlural;
      else
          letras = strSingular;

  if (resto > 0)
      letras += "";

  return letras;
}//seccionNum()

function milesNum(num) {
  let divisor = 1000;
  let cientos = Math.floor(num / divisor)
  let resto = num - (cientos * divisor)

  let strMiles = seccionNum(num, divisor, "UN MIL", "MIL");
  let strCentenas = centenasNum(resto);

  if(strMiles === "")
      return strCentenas;

  return strMiles + " " + strCentenas;
}//milesNum()

function millonesNum(num) {
  let divisor = 1000000;
  let cientos = Math.floor(num / divisor)
  let resto = num - (cientos * divisor)

  let strMillones = seccionNum(num, divisor, "UN MILLON DE", "MILLONES DE");
  let strMiles = milesNum(resto);

  if(strMillones === "")
      return strMiles;

  return strMillones + " " + strMiles;
}//millonesNum()

function numeroALetras(num) {
  var data = {
      numero: num,
      enteros: Math.floor(num),
      centavos: (((Math.round(num * 100)) - (Math.floor(num) * 100))),
      letrasCentavos: "",
      letrasMonedaPlural: 'PESOS',//"PESOS", 'Dólares', 'Bolívares', 'etcs'
      letrasMonedaSingular: 'PESO', //"PESO", 'Dólar', 'Bolivar', 'etc'

      letrasMonedaCentavoPlural: "CENTAVOS",
      letrasMonedaCentavoSingular: "CENTAVO"
  };

  if (data.centavos > 0) {
      data.letrasCentavos = "CON " + (function (){
          if (data.centavos === 1)
              return millonesNum(data.centavos) + " " + data.letrasMonedaCentavoSingular;
          else
              return millonesNum(data.centavos) + " " + data.letrasMonedaCentavoPlural;
          })();
  };

  if(data.enteros === 0)
      return "CERO " + data.letrasMonedaPlural + " " + data.letrasCentavos;
  if (data.enteros == 1)
      return millonesNum(data.enteros) + " " + data.letrasMonedaSingular + " " + data.letrasCentavos;
  else
      return millonesNum(data.enteros) + " " + data.letrasMonedaPlural + " " + data.letrasCentavos;
}//numeroALetras()
//FIN NUMERO A LETRAS

class Home extends React.Component{
  state={showEstructura: true, addEstructura: false, verEstructura: false,
    showUser: false,
    showCar: false, showLab: false, showProg: false, showConfig: false, showSimula: false, showAdmin: false, showIndEmp: false, showBitaEmp: false, 
    showGer: false, showAddEstruct: false, showUpdEstruct: false, showUpdEq: false, showUpdEqAc: false, showAsDocEq: false,
    permiteMovFinanc: false, permiteHistEgreso: false, permiteHistIngreso: false,
    permiteUpdate: false, permiteDelete: false,
    argsAdd: {}, errorAdd: [],
    // argsBuscEstruct: {descrEmpresa: localStorage.getItem('Empresa')==="Todas..."?"Seleccionar Empresa...":localStorage.getItem('Empresa')},
    argsBuscEstruct: {descrEmpresa: "Seleccionar Empresa..."},
    idLista: {},
    argsQuery: `{"$unwind": "$secciones"},
      {"$unwind": "$secciones.equipos"},
      {"$unwind": "$secciones.equipos.componentes"},
      {"$unwind": "$secciones.equipos.componentes.mecanismos"},
      {$project: {idPlanta: '$_id', descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
        descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
        descrEquipo: '$secciones.equipos.descrEquipo', codComponente: '$secciones.equipos.componentes.codComponente',
        descrComponente: '$secciones.equipos.componentes.descrComponente',
        codMecanismo: '$secciones.equipos.componentes.mecanismos.codMecanismo',
        codigoQR: '$secciones.equipos.componentes.mecanismos.codigoQR',
        descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
        estado: '$secciones.equipos.componentes.mecanismos.estado',
        ultInforme: '$secciones.equipos.componentes.mecanismos.ultInforme',
        nomArchivo: '$secciones.equipos.componentes.mecanismos.nomArchivo',
        descrFabricante: '$secciones.equipos.componentes.mecanismos.descrFabricante',
        descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante',
        categoriaLub: '$secciones.equipos.componentes.mecanismos.categoriaLub',
        tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
        tipoGrado: '$secciones.equipos.componentes.mecanismos.tipoGrado',
        descrGrado: '$secciones.equipos.componentes.mecanismos.descrGrado',
        descrAplicacion: '$secciones.equipos.componentes.mecanismos.descrAplicacion',
        tipoFrecuencia: '$secciones.equipos.componentes.mecanismos.tipoFrecuencia',
        abrevUnidadTF: '$secciones.equipos.componentes.mecanismos.abrevUnidadTF',
        cantidadTotal: '$secciones.equipos.componentes.mecanismos.cantidadTotal',
        descrUnidad: '$secciones.equipos.componentes.mecanismos.descrUnidad',
        abrevUnidad: '$secciones.equipos.componentes.mecanismos.abrevUnidad'}}`,
      argsQuery1: `{"$unwind": "$secciones"},
        {"$unwind": "$secciones.equipos"},
        {"$unwind": "$secciones.equipos.componentes"},
        {"$unwind": "$secciones.equipos.componentes.mecanismos"},
        {$project: {_id: 1,
          descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
          descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
          descrEquipo: '$secciones.equipos.descrEquipo', 
          codComponente: '$secciones.equipos.componentes.codComponente',
          descrComponente: '$secciones.equipos.componentes.descrComponente',
          codMecanismo: '$secciones.equipos.componentes.mecanismos.codMecanismo',
          descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
          descrUtilidad: '$secciones.equipos.componentes.mecanismos.descrUtilidad',
          descrAplicacion: '$secciones.equipos.componentes.mecanismos.descrAplicacion',
          tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
          descrFabricante: '$secciones.equipos.componentes.mecanismos.descrFabricante',
          descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante',
          tipoFrecuencia: '$secciones.equipos.componentes.mecanismos.tipoFrecuencia',
          tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
          tipoGrado: '$secciones.equipos.componentes.mecanismos.tipoGrado',
          abrevUnidadTF: '$secciones.equipos.componentes.mecanismos.abrevUnidadTF',
          cantidadTotal: '$secciones.equipos.componentes.mecanismos.cantidadTotal',
          descrUnidad: '$secciones.equipos.componentes.mecanismos.descrUnidad',
          abrevUnidad: '$secciones.equipos.componentes.mecanismos.abrevUnidad',
          codigoQR: '$secciones.equipos.componentes.mecanismos.codigoQR'}}
        `,  
        argsQuery2: `{"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {$project: {_id: 1,
            imagenes: {

              $let: {
                vars: {regImg: { $cond: { if: { $isArray: "$secciones.equipos.imagenes" },
                                              then: { $size: "$secciones.equipos.imagenes" },
                                              else: 0} }
                },
                in: { $cond: { if: { $gt: [ "$$regImg", 0 ] },
                                    then: "$secciones.equipos.imagenes",
                                    else: [{nombreImagen: null, ordenImagen: null}] } }
            }},
            descrEmpresa: 1, descrPlanta: 1, 
            descrSeccion: '$secciones.descrSeccion', 
            descrEquipo: '$secciones.equipos.descrEquipo', 
            cedula: '$secciones.equipos.cedula',
            numCarta: '$secciones.equipos.numCarta', descrPrograma: '$secciones.equipos.descrPrograma'}},
          {"$unwind": "$imagenes"},
          {$project: {_id: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: 1, 
            descrEquipo: 1, cedula: 1, numCarta: 1, descrPrograma: 1,
            nombreImagen: '$imagenes.nombreImagen', ordenImagen: '$imagenes.ordenImagen'}},
            {$group: {_id: {descrEmpresa: '$descrEmpresa', descrPlanta: '$descrPlanta', descrSeccion: '$descrSeccion', descrEquipo: '$descrEquipo', cedula: '$cedula', numCarta: '$numCarta', descrPrograma: '$descrPrograma', nombreImagen: '$nombreImagen', ordenImagen: '$ordenImagen'}}},
            {$project: {_id: 0, descrEmpresa: '$_id.descrEmpresa', descrPlanta: '$_id.descrPlanta', descrSeccion: '$_id.descrSeccion', descrEquipo: '$_id.descrEquipo', cedula: '$_id.cedula',  numCarta: '$_id.numCarta', descrPrograma: '$_id.descrPrograma', nombreImagen: '$_id.nombreImagen', ordenImagen: '$_id.ordenImagen'}},
            {$sort: {descrEmpresa: 1, descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, numCarta: 1, ordenImagen: 1}}`,
      argsQuery3: `{"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {$project: {_id: 1, idPlanta: "$_id",
              documentos: {
                $let: {
                   vars: {regProg: { $cond: { if: { $isArray: "$secciones.equipos.documentos" },
                                                then: { $size: "$secciones.equipos.documentos" },
                                                else: 0} }
                   },
                   in: { $cond: { if: { $gt: [ "$$regProg", 0 ] },
                                       then: "$secciones.equipos.documentos",
                                       else: [{nombreDoc: null}] } }
              }},
            descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
            descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
            descrEquipo: '$secciones.equipos.descrEquipo'}},
          {"$unwind": "$documentos"},
          {$project: {_id: 1, idPlanta: 1, descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: 1, descrSeccion: 1,
              codEquipo: 1, descrEquipo: 1,
              nombreDoc: '$documentos.nombreDoc'
          }}`,
      argsQuery4: `{"$unwind": "$secciones"},
      {"$unwind": "$secciones.equipos"},
      {"$unwind": "$secciones.equipos.componentes"},
      {"$unwind": "$secciones.equipos.componentes.mecanismos"},
      {$project: {idPlanta: '$_id', descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
        descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
        descrEquipo: '$secciones.equipos.descrEquipo', 
        acumulado: '$secciones.equipos.acumulado', 
        horasKmPorDia: '$secciones.equipos.horasKmPorDia', 
        tipoFrecuencia: '$secciones.equipos.componentes.mecanismos.tipoFrecuencia'}},
      {$match: {tipoFrecuencia: {$in: ['Horas', 'Km']}}},
      {$group: {_id: {descrEmpresa: '$descrEmpresa', descrPlanta: '$descrPlanta', descrSeccion: '$descrSeccion', descrEquipo: '$descrEquipo', acumulado: '$acumulado', horasKmPorDia: '$horasKmPorDia', tipoFrecuencia: '$tipoFrecuencia'}}},
      {$project: {_id: 0, descrEmpresa: '$_id.descrEmpresa', descrPlanta: '$_id.descrPlanta', descrSeccion: '$_id.descrSeccion', descrEquipo: '$_id.descrEquipo', acumulado: '$_id.acumulado',  horasKmPorDia: '$_id.horasKmPorDia', tipoFrecuencia: '$_id.tipoFrecuencia'}},
      {$sort: {descrEmpresa: 1, descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, tipoFrecuencia: 1}}`    
    } 

  logout = () => {
    // console.log(localStorage.getItem('userLogin'))
    // console.log(localStorage.getItem('token'))
    // console.log(localStorage.getItem('token1'))

    localStorage.removeItem('token');
    localStorage.removeItem('token1');
    localStorage.removeItem('token2');
    localStorage.removeItem('Empresa');
    localStorage.removeItem('userLogin');

    console.log("se salioooooo")
    this.props.history.push("/")
    // return <Redirect to="/" />
  }

  validarHandle = (campo1, campo1Val, campo1Sel, campo1Msg,
    campo2, campo2Val, campo2Sel, campo2Msg,
    campo3, campo3Val, campo3Sel, campo3Msg,
    campo4, campo4Val, campo4Sel, campo4Msg,
    campo5, campo5Val, campo5Sel, campo5Msg,
    campo6, campo6Val, campo6Sel, campo6Msg,
    campo7, campo7Val, campo7Sel, campo7Msg,
    campo8, campo8Val, campo8Sel, campo8Msg,
    campo9, campo9Val, campo9Sel, campo9Msg)=>{

    const argsAdd = this.state.argsAdd
    const errors = [];
    if(campo1!=='XXX' && (!campo1 || campo1===campo1Sel)){
      argsAdd[campo1Val] = campo1Sel;
      errors.push({path: campo1Val, message: campo1Msg});
    }
    if(campo2!=='XXX' && (!campo2 || campo2===campo2Sel)){
      argsAdd[campo2Val] = campo2Sel;
      errors.push({path: campo2Val, message: campo2Msg});
    }
    if(campo3!=='XXX' && (!campo3 || campo3===campo3Sel)){
      argsAdd[campo3Val] = campo3Sel;
      errors.push({path: campo3Val, message: campo3Msg});
    }
    if(campo4!=='XXX' && (!campo4 || campo4===campo4Sel)){
      argsAdd[campo4Val] = campo4Sel;
      errors.push({path: campo4Val, message: campo4Msg});
    }
    if(campo5!=='XXX' && (!campo5 || campo5===campo5Sel)){
      argsAdd[campo5Val] = campo5Sel;
      errors.push({path: campo5Val, message: campo5Msg});
    }
    if(campo6!=='XXX' && (!campo6 || campo6===campo6Sel)){
      argsAdd[campo6Val] = campo6Sel;
      errors.push({path: campo6Val, message: campo6Msg});
    }
    if(campo7!=='XXX' && (!campo7 || campo7===campo7Sel)){
      argsAdd[campo7Val] = campo7Sel;
      errors.push({path: campo7Val, message: campo7Msg});
    }
    if(campo8!=='XXX' && (!campo8 || campo8===campo8Sel)){
      argsAdd[campo8Val] = campo8Sel;
      errors.push({path: campo8Val, message: campo8Msg});
    }
    if(campo9!=='XXX' && (!campo9 || campo9===campo9Sel)){
      argsAdd[campo9Val] = campo9Sel;
      errors.push({path: campo9Val, message: campo9Msg});
    }

    this.setState({argsAdd});
    this.setState({errorAdd: errors})
  }

  estadosFalse = () => {
    this.setState({argsAdd: {}})
    this.setState({errorAdd: []})

    Object.values(this.state).forEach((estado, i) => {
      if(estado===true){
        // console.log(Object.getOwnPropertyNames(this.state)[i])
        // if(typeof estado === "boolean"){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await this.props.editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  nextValFra = async (name) => {
    const argsUpd = {
      _id: name,
    }
    const response = await this.props.editSeqFrafindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqFrafindOneAndUpdate.proxFact
  }
  
//ACTUALIZAR BD
crudBD = async (operacionCRUD, args, i)=>{
  console.log(operacionCRUD)
      if(args.ctrlCampo === 'CRUD'){
// console.log(i)
// console.log(args)
        const {data} = await operacionCRUD({
          variables: args
        });
  
  //Se utiliza para traer el _id del documento creado
        if(args.ctrl_id === 'SI_ID'){
          if(Object.values(data)[0]._id){
            return Object.values(data)[0]._id
          }else{
            return 0
          }
        }
      }else{
        if(args.ctrlCampo === "MANY"){
console.log("MANY")
console.log(args)
          const {data} = await operacionCRUD({
            variables: args
          });
        }
      }
    }

    updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
        let codigo = 0
        if(argsCrud[0].ctrl_id === 'SI_ID'){
          codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
        }else{
          console.log("11111111", crudColecc[0], argsCrud[0])
          await this.crudBD(crudColecc[0], argsCrud[0], 0)
          console.log("22222222", crudColecc[0], argsCrud[0])
        }
        if(codigo!==0){
          for(let i=1; i<totDocCRUD; i++){
            argsCrud[i]._id = codigo
          }
        }
  console.log("inicio")
        for(let i=1; i<totDocCRUD; i++){
          await this.crudBD(crudColecc[i], argsCrud[i], i)
        }
  console.log("final")
      }

  showEstructura = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showEstructura: true})
  }

  showAddEstruct = async (ev) => {
    ev.preventDefault()

    this.estadosFalse()
    this.setState({showAddEstruct: true})
  }

  showUpdEstruct = async (ev) => {
    ev.preventDefault()

    this.estadosFalse()
    this.setState({showUpdEstruct: true})
  }

  showUpdEq = async (ev) => {
    ev.preventDefault()

    this.estadosFalse()
    this.setState({showUpdEq: true})
  }

  showUpdEqAc = async (ev) => {
    ev.preventDefault()

    this.estadosFalse()
    this.setState({showUpdEqAc: true})
  }

  showUser = (ev) => {
    ev.preventDefault()
    this.props.allUsuarios.refetch()
    this.estadosFalse()
    this.setState({showUser: true})
  }

  showCar = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showCar: true})
  }

  showLab = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showLab: true})
  }

  showProg = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showProg: true})
  }

  showConfig = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showConfig: true})
  }

  showSimula = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showSimula: true})
  }

  showAdmin = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showAdmin: true})
  }

  showGer = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showGer: true})
  }

  showAsDocEq = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showAsDocEq: true})
  }

  addEstructura = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addEstructura: true})
  }

  addTipocli = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addTipocli: true})
  }

  addGrupoaf = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addGrupoaf: true})
  }

  addTipodoc = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addTipodoc: true})
  }

  addTipoAju = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addTipoAju: true})
  }

  showIndEmp = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showIndEmp: true})
  }
  showBitaEmp = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showBitaEmp: true})
  }

  handleChange = (ev, input)=>{
    const argsAdd = this.state.argsAdd

    let datoTipo = ""
    if(input!==undefined&&ev.target.name===undefined){
      datoTipo = input.type
    }

    if(datoTipo==='checkbox'){
      if (this.state.addEstructura) {
        argsAdd[input.name] = input.label
      }else{
        argsAdd[input.name] = input.checked
      }
    }else{
      if(ev.target.type==='checkbox'){
        argsAdd[ev.target.name] = ev.target.checked
      }else{
        argsAdd[ev.target.name] = ev.target.value
      }
    }
    this.setState({argsAdd});
    // console.log(argsAdd)
  }
  
  handleChangeBuscEstruct = (ev)=>{
    // console.log(ev.target.name)
    // console.log(ev.target.value)
    const argsBuscEstruct = this.state.argsBuscEstruct
    if(ev.target.name === "numDocum"){
      var numDocum = document.getElementById("numDocum");
      if(ev.target.value<=0){
        numDocum.value = ""
        argsBuscEstruct[ev.target.name] = ""
      }else{
        argsBuscEstruct[ev.target.name] = ev.target.value
      }
    }else{
      if(ev.target.name==="descrPlantaB"){
        argsBuscEstruct["descrPlanta"] = ev.target.value
      }else{
        if(ev.target.name==="descrSeccionB"){
          argsBuscEstruct["descrSeccion"] = ev.target.value
        }else{
          if(ev.target.name==="descrEquipoB"){
            argsBuscEstruct["descrEquipo"] = ev.target.value
          }else{
            if(ev.target.name==="descrComponenteB"){
              argsBuscEstruct["descrComponente"] = ev.target.value
            }else{
              if(ev.target.name==="descrMecanismoB"){
                argsBuscEstruct["descrMecanismo"] = ev.target.value
              }else{
                if(ev.target.name==="estadoB"){
                  argsBuscEstruct["estado"] = ev.target.value
                }else{
                  argsBuscEstruct[ev.target.name] = ev.target.value
                }              }            
            }
          }
        }
      }
      // argsBuscEstruct[ev.target.name] = ev.target.value
    }
    // console.log(argsBuscEstruct)
    this.setState({argsBuscEstruct});
    this.handleBuscEstruct(argsBuscEstruct)
  }

  handleBuscEstruct = async (argsBuscEstruct) => {
    let argsBuscar={}
    // console.log(this.state.argsBuscEstruct)
    // if(argsBuscEstr.descrEmpresa){
    //   argsBuscEstruct = argsBuscEstr
    // }else{
      // let argsBuscEstruct = this.state.argsBuscEstruct
    // }
    argsBuscar.descrEmpresa=argsBuscEstruct.descrEmpresa
    if(argsBuscEstruct.numDocum){
      argsBuscar.numDocum=parseInt(argsBuscEstruct.numDocum, 10)
    }else{
      // argsBuscar.numDocum=100
    }
    if(argsBuscEstruct.descrPlanta){
      argsBuscar.descrPlanta=argsBuscEstruct.descrPlanta
    }else{
      delete argsBuscar.descrPlanta
    }
    if(argsBuscEstruct.descrSeccion){
      argsBuscar.descrSeccion=argsBuscEstruct.descrSeccion
    }else{
      delete argsBuscar.descrSeccion
    }
    if(argsBuscEstruct.descrEquipo){
      argsBuscar.descrEquipo=argsBuscEstruct.descrEquipo
    }else{
      delete argsBuscar.descrEquipo
    }
    if(argsBuscEstruct.descrComponente){
      argsBuscar.descrComponente=argsBuscEstruct.descrComponente
    }else{
      delete argsBuscar.descrComponente
    }
    if(argsBuscEstruct.descrMecanismo){
      argsBuscar.descrMecanismo=argsBuscEstruct.descrMecanismo
    }else{
      delete argsBuscar.descrMecanismo
    }
    if(argsBuscEstruct.estado){
      argsBuscar.estado=argsBuscEstruct.estado
    }else{
      delete argsBuscar.estado
    }
    this.setState({argsBuscEstruct: argsBuscar});

//VALIDAR SI MODIFICARON EL localStorage userLogin o Empresa
    const argsEncr = {
      valor: localStorage.getItem('userLogin'),
      comparar: localStorage.getItem('token1')
    }
    const response = await this.props.encriptar({
      variables: argsEncr
    });
    const {success} = response.data.encriptar;
    let enapp = success
    if(enapp){
      const argsEncr = {
        valor: localStorage.getItem('Empresa'),
        comparar: localStorage.getItem('token2')
      }
      const response = await this.props.encriptar({
        variables: argsEncr
      });
      const {success} = response.data.encriptar;
      enapp = success  
    }
    if (!enapp){
//MODIFICARON EL localStorage userLogin o Empresa
      localStorage.removeItem('token');
      localStorage.removeItem('token1');
      localStorage.removeItem('token2');
      localStorage.removeItem('Empresa');
      localStorage.removeItem('userLogin');
console.log("ojo")
      this.props.history.push("/")
    }
  }

  handlePlanta = async (ev, args, descrPlantaAnt, descrSeccionAnt, descrEquipoAnt, descrComponenteAnt, descrMecanismoAnt,
        codPlantaAnt, codSeccionAnt, codEquipoAnt, codComponenteAnt, codMecanismoAnt)=>{
    console.log(args)
    console.log(this.state.permiteUpdate, this.state.permiteDelete)
    // console.log(descrPlantaAnt, descrSeccionAnt, descrEquipoAnt, descrComponenteAnt, descrMecanismoAnt)
    if((!args.descrPlanta||!args.descrSeccion||!args.descrEquipo||!args.descrComponente||
      !args.descrMecanismo)&&!this.state.permiteDelete){

      if(!args.descrPlanta){
        const argsAdd = this.state.argsAdd
        const errors = [];
        errors.push({path: 'codPlanta', message: "Debe escribir la descripción de la Planta"});
        this.setState({argsAdd});
        this.setState({errorAdd: errors})
      }else{
        this.validarHandle(args.descrPlanta, 'descrPlanta', '', 'Debe escribir la descripción de la Planta',
                          // args.codSeccion, 'codSeccion', '', 'Debe escribir el código de la Seccion',
                          args.descrSeccion, 'descrSeccion', '', 'Debe escribir la descripción de la Seccion',
                          // args.codEquipo, 'codEquipo', '', 'Debe escribir el código del Equipo',
                          args.descrEquipo, 'descrEquipo', '', 'Debe escribir la descripción del Equipo',
                          // args.codComponente, 'codComponente', '', 'Debe escribir el código del Componente',
                          args.descrComponente, 'descrComponente', '', 'Debe escribir la descripción del Componente',
                          // args.codMecanismo, 'codMecanismo', '', 'Debe escribir el código del Mecanismo',
                          args.descrMecanismo, 'descrMecanismo', '', 'Debe escribir la descripción del Mecanismo',
                          args.descrLubricante, 'descrLubricante', '', 'Debe seleccionar el lubricante',
                          args.descrAplicacion, 'descrAplicacion', '', 'Debe seleccionar la aplicación',
                          args.tipoFrecuencia, 'tipoFrecuencia', '', 'Debe seleccionar el tipo de frecuencia',
                          args.descrUnidad, 'descrUnidad', '', 'Debe seleccionar la unidad de medida del lubricante')
      }
    }else{
        if(this.state.addEstructura){

        }else{
          if(this.state.permiteUpdate || this.state.permiteDelete){
            var miLista = document.getElementById("miLista1");
            var miLista2 = document.getElementById("miLista2");
            var miLista3 = document.getElementById("miLista3");
            let indexColor = -1
            let colorTexto=""
            if(this.state.permiteUpdate){
              indexColor = this.props.allGrado.allGrado.findIndex( grado => grado.tipoGrado===miLista.options[miLista.selectedIndex].attributes[3].value 
              && grado.descrGrado===miLista.options[miLista.selectedIndex].attributes[4].value)
            
              if(indexColor!==-1){
                colorTexto = this.props.allGrado.allGrado[indexColor].colorTexto
              }
            }
            const argsUpd = {
              _id: args._id,
              descrEmpresa: args.descrEmpresa,
              codPlanta: args.codPlanta,
              descrPlanta: args.descrPlanta,
              codSeccion: args.codSeccion,
              descrSeccion: args.descrSeccion,

              codEquipo: args.codEquipo,
              descrEquipo: args.descrEquipo,
              codComponente: args.codComponente,
              descrComponente: args.descrComponente,
              codMecanismo: args.codMecanismo,
              descrMecanismo: args.descrMecanismo,
              descrLubricante: args.descrLubricante,
              descrAplicacion: args.descrAplicacion,
              colorAplicacion:miLista2.options[miLista2.selectedIndex].attributes[0].value,           
              tipoFrecuencia: args.tipoFrecuencia,
              descrUnidad: args.descrUnidad,
              abrevUnidad: miLista3.options[miLista3.selectedIndex].attributes[0].value,
              cantidadTotal: args.cantidadTotal,
              tipoLub: miLista.options[miLista.selectedIndex].attributes[0].value,            
              descrFabricante: this.state.permiteUpdate?miLista.options[miLista.selectedIndex].attributes[1].value:'',            
              categoriaLub: this.state.permiteUpdate?miLista.options[miLista.selectedIndex].attributes[2].value:'',            
              tipoGrado: this.state.permiteUpdate?miLista.options[miLista.selectedIndex].attributes[3].value:'',   
              descrGrado: this.state.permiteUpdate?miLista.options[miLista.selectedIndex].attributes[4].value:'',            
              colorGrado: this.state.permiteUpdate?miLista.options[miLista.selectedIndex].attributes[5].value:'',            
              apiSAE: this.state.permiteUpdate?miLista.options[miLista.selectedIndex].attributes[6].value==='No aplica'?'':miLista.options[miLista.selectedIndex].attributes[6].value:'',   
              colorTexto: colorTexto,
              isoGrasa: this.state.permiteUpdate?miLista.options[miLista.selectedIndex].attributes[7].value==='No aplica'?'':miLista.options[miLista.selectedIndex].attributes[7].value:'',   
              isoGrasaColor: this.state.permiteUpdate?miLista.options[miLista.selectedIndex].attributes[8].value==='No aplica'?'':miLista.options[miLista.selectedIndex].attributes[8].value:'',   
              isoGrasaTexto: this.state.permiteUpdate?miLista.options[miLista.selectedIndex].attributes[9].value==='No aplica'?'':miLista.options[miLista.selectedIndex].attributes[9].value:'',   
              descrPlantaAnt: descrPlantaAnt,
              descrSeccionAnt: descrSeccionAnt,
              descrEquipoAnt: descrEquipoAnt,
              descrComponenteAnt: descrComponenteAnt,
              descrMecanismoAnt: descrMecanismoAnt,
            }
            if(this.state.permiteUpdate){
              let response = await this.props.editPlanta({variables: argsUpd});
              argsUpd.tipoAct = "EditarSeccion"
              response = await this.props.editPlantaUpdSeccion({variables: argsUpd});
              argsUpd.tipoAct = "EditarEquipo"
              response = await this.props.editPlantaUpdSeccion({variables: argsUpd});
              argsUpd.tipoAct = "EditarComponente"
              response = await this.props.editPlantaUpdSeccion({variables: argsUpd});
              argsUpd.tipoAct = "EditarMecanismo"
              response = await this.props.editPlantaUpdSeccion({variables: argsUpd});
              console.log(argsUpd)
            }else{
              let elimCo = 2, elimEq = 2, elimSe = 2, elimPl = 2
              //Revisar si es necesario eliminar el componente (tiene un mecanismo)
              let argsElim1 = `[{$match: {descrEmpresa: '${args.descrEmpresa}'}},
                {"$unwind": "$secciones"},
                {"$unwind": "$secciones.equipos"},
                {"$unwind": "$secciones.equipos.componentes"},
                {"$unwind": "$secciones.equipos.componentes.mecanismos"},
                {$project: {_id: 1, descrEmpresa: 1, descrPlanta: 1,
                  descrSeccion: '$secciones.descrSeccion',
                  descrEquipo: '$secciones.equipos.descrEquipo',
                  descrComponente: '$secciones.equipos.componentes.descrComponente',
                  descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo'}},`
  
              let argsElim2 = `{$match: {descrPlanta: '${args.descrPlanta}', descrSeccion: '${args.descrSeccion}',
                    descrEquipo: '${args.descrEquipo}', descrComponente: '${args.descrComponente}'}},
                {$group: {_id: {descrPlanta: '$descrPlanta', descrSeccion: '$descrSeccion', descrEquipo: '$descrEquipo',
                    descrComponente: '$descrComponente'}, cantidadTotal: {$sum: 1}}},
                ]`
              let argsElim = {tipoqry: `${argsElim1}
                ${argsElim2}`}
              console.log(argsElim)
              let {data} = await this.props.allPlantaRtes2.refetch(argsElim)
              if(data.allPlantaRtes.length>0){
                elimCo = await data.allPlantaRtes[0].cantidadTotal
                console.log(elimCo)
              }
              // console.log("11")
              if(elimCo<2){
                console.log(elimCo)
                // Se elimina el componente
                // elimCo = true
                //Revisar si es necesario eliminar el equipo (tiene un componente)
                argsElim2 = `{$match: {descrPlanta: '${args.descrPlanta}', descrSeccion: '${args.descrSeccion}',
                  descrEquipo: '${args.descrEquipo}'}},
                    {$group: {_id: {descrPlanta: '$descrPlanta', descrSeccion: '$descrSeccion',
                        descrEquipo: '$descrEquipo'}, cantidadTotal: {$sum: 1}}},
                  ]`
                  let argsElim = {tipoqry: `${argsElim1}
                    ${argsElim2}`}
                console.log(argsElim)
                let {data} = await this.props.allPlantaRtes2.refetch(argsElim)
                elimEq = await data.allPlantaRtes[0].cantidadTotal
                console.log("22")
                if(elimEq<2){
                  // Se elimina el equipo
                  // elimEq = true
                  //Revisar si es necesario eliminar la sección (tiene un equipo)
                  argsElim2 = `{$match: {descrPlanta: '${args.descrPlanta}', descrSeccion: '${args.descrSeccion}'}},
                      {$group: {_id: {descrPlanta: '$descrPlanta', descrSeccion: '$descrSeccion'},
                      cantidadTotal: {$sum: 1}}},
                    ]`
                    let argsElim = {tipoqry: `${argsElim1}
                      ${argsElim2}`}
                  console.log(argsElim)
                  let {data} = await this.props.allPlantaRtes2.refetch(argsElim)
                  elimSe = await data.allPlantaRtes[0].cantidadTotal
                  // console.log("33")
                  if(elimSe<2){
                    // Se elimina la sección
                    // elimSe = true
                    //Revisar si es necesario eliminar la planta (tiene una sección)
                    argsElim2 = `{$match: {descrPlanta: '${args.descrPlanta}'}},
                        {$group: {_id: {descrPlanta: '$descrPlanta'},
                        cantidadTotal: {$sum: 1}}},
                      ]`
                      let argsElim = {tipoqry: `${argsElim1}
                        ${argsElim2}`}
                    // console.log(argsElim)
                    let {data} = await this.props.allPlantaRtes2.refetch(argsElim)
                    elimPl = await data.allPlantaRtes[0].cantidadTotal
                    // console.log("44")
                    // if(elimPl<2){
                      // Se elimina la planta
                      // elimPl = true
                    // }
                  }
                }  
              }
              // console.log(elimPl, elimSe, elimEq, elimCo)
              if(elimPl<2){
                const argsDel = {
                  _id: args._id
                }
                // console.log(argsDel)
                await this.props.deletePlanta({variables: argsDel});                
              }else{
                if(elimSe<2){
                  argsUpd.tipoAct = "EliminarSeccion"
                }else{
                  if(elimEq<2){
                    argsUpd.tipoAct = "EliminarEquipo"
                  }else{
                    if(elimCo<2){
                      argsUpd.tipoAct = "EliminarComponente"
                    }else{
                      argsUpd.tipoAct = "EliminarMecanismo"
                    }
                  }
                }
                console.log(argsUpd)
                await this.props.editPlantaUpdSeccion({variables: argsUpd});            
                }
            }
            this.estadosFalse()
            this.setState({showEstructura: true})
          }
          if(this.state.permiteDelete){
            // const argsUpd = {
            //   _id: args._id,
            //   descrPlanta: args.descrPlanta,
            //   descrSeccion: args.descrSeccion,
            //   descrEquipo: args.descrEquipo,
            //   descrComponente: args.descrComponente,
            //   descrMecanismo: args.descrMecanismo,
            //   tipoAct: "EliminarMecanismo"
            // }
            // console.log(argsUpd)
            // let response = await this.props.editPlantaUpdSeccion({variables: argsUpd});
            // this.estadosFalse()
            // this.setState({showEstructura: true})
          }
        }
      // }
    }
  }

  handleUpdAsDocEq = async (ev, idListaP)=>{
    // console.log(ev.target.files)
    console.log(idListaP)
    let listImg = ev.target.files

    if(idListaP.descrEquipo){
      let numImgAsoc = 0

      let validImg = []
      // validImg.forEach(async (elemento, i) => {
      for(let ii=0; ii<listImg.length; ii++){
        console.log(listImg[ii].name)

                
// //quitar espacios en blanco al nombre del archivo
// let nombreArch = listImg[ii].name.replace(/^\s+|\s+/g, '')
// console.log(nombreArch)

        //VALIDAR SI EL ARCHIVO EXISTE (ESTA EN LA CARPETA => NO SE COPIA)
        let argsBuscar = {}
        argsBuscar = `'descrEmpresa': '${idListaP.descrEmpresa}', 'nombreDoc': '${listImg[ii].name}'`
        let argsBuscarPl = {}
        let argsQuery = `{"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.documentos"},
          {$project: {idPlanta: '$_id', descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
            descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
            descrEquipo: '$secciones.equipos.descrEquipo', nombreDoc: '$secciones.equipos.documentos.nombreDoc'}}`
        argsBuscarPl = {tipoqry: `[${argsQuery}, {$match: {${argsBuscar}}}]`}
        console.log(argsBuscarPl)
        let regExisteArch = [], regExiste = 0

        if(this.props.allPlantaRtes1.allPlantaRtes){
          let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
          console.log(this.props.allPlantaRtes1.allPlantaRtes.length)
          regExisteArch = await data.allPlantaRtes

          for(let iii=0; iii<regExisteArch.length; iii++){
            if(regExisteArch[iii].descrEmpresa===idListaP.descrEmpresa&&
                  regExisteArch[iii].descrPlanta===idListaP.descrPlanta&&
                  regExisteArch[iii].descrSeccion===idListaP.descrSeccion&&
                  regExisteArch[iii].descrEquipo===idListaP.descrEquipo){
              regExiste = 1
            }
          }
        }

        validImg.push({name: listImg[ii].name, existe: regExiste, existeArch: regExisteArch.length})
        if(regExiste===0){
          numImgAsoc += 1
        }
        console.log(regExiste, regExisteArch)
      }
console.log(validImg)

      if(numImgAsoc>0){
        document.body.style.cursor = 'wait'
      }

      // console.log(this.state.idListaP.descrEquipo)
      let file = ""
      //Se define el ancho y alto de la imagen (entre mas grande mejor resolucion)
      // let ancho = 800
      // let alto = 532
      for(let ii=0; ii<listImg.length; ii++){
        if(validImg[ii].existe===0){
          // console.log(listImg[ii].name, validImg[ii].name, validImg[ii].existe)
          file = listImg[ii]
          // console.log(URL.createObjectURL(file))

          //COPIA EL ARCHIVO EN LA CARPETA DEL SERVIDOR './slcm-client/public/images/cartas'
          let archCopiado = ""
          if(validImg[ii].existeArch===0){
            console.log("Existe archivo")
            let response = await this.props.singleUpload({variables: {file}});
            archCopiado = response.data.singleUpload.filename
            console.log("Copiado")
          }{
            // console.log("NO se copia")
          }

          //PROCESO PARA GUARDAR LA IMAGEN EN LA BASE DE DATOS
          const updState = async (data, name) => {
            console.log("Guardar 1")

            let response = await this.props.fecha({
              variables: {}
            });
            const {fechaHoraHoy} = response.data.fecha

            let addColeccPl = []

            let argsImagen = {}, addColeccImg = []
            let argsEqu = {}, addColeccEqu = []
            let argsSecc = {}, addColeccSecc = []
            let argsPl = {}
            //IMAGEN NUEVA

            console.log(idListaP)
            argsImagen['nombreDoc'] = name
            argsImagen['fechaCreate'] = fechaHoraHoy
            argsImagen['usuarioCreate'] = localStorage.getItem('userLogin')

            addColeccImg.push(argsImagen)

            argsEqu['descrEquipo'] = idListaP.descrEquipo
            argsEqu['documentos'] = addColeccImg
            addColeccEqu.push(argsEqu)
            argsSecc['descrSeccion'] = idListaP.descrSeccion
            argsSecc['equipos'] = addColeccEqu
            addColeccSecc.push(argsSecc)
            argsPl['secciones'] = addColeccSecc

            argsPl['descrEmpresa'] = idListaP.descrEmpresa
            argsPl['_id'] = idListaP.idPlanta
            argsPl['descrPlanta'] = idListaP.descrPlanta
            if(archCopiado){
              argsPl['descrComponente'] = archCopiado
            }else{
              argsPl['descrComponente'] = ""
            }
            argsPl['descrComponenteAnt'] = idListaP.descrEmpresa.replace(/\./g,'') //quitar puntos
            argsPl['tipoAct'] = "CrearDoc"
            addColeccPl.push(argsPl)
          
            let addColeccImg1 = []
            addColeccImg = []
            for(let iii=0; iii<addColeccPl.length; iii++){
              addColeccImg.push(addColeccPl[iii])
            }
            console.log(addColeccImg)
console.log("33", archCopiado)
            addColeccImg1.push({planta: addColeccImg})
// console.log("44")
            let numDocCRUD = 0
            let totDocCRUD = 1
            let argsCrud = []
            let crudColecc = []
            for(let iii=0; iii<totDocCRUD; iii++){
              argsCrud.push({ctrlCampo: 'NO_CRUD'})
            }
            for(let iii=0; iii<totDocCRUD; iii++){
              crudColecc.push(this.props.editPlantaEstructura)
            }

            argsCrud[numDocCRUD] = addColeccImg1[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.editPlantaEstructura

            console.log(argsCrud)
            await this.updColecc(crudColecc, argsCrud, totDocCRUD)
            //FIN IMAGEN NUEVA
console.log(addColeccImg1[0])
// console.log("111")
            if(ii===listImg.length-1){
              document.body.style.cursor = 'default'
              alert("!! Proceso finalizado !!")

              const argsBuscEstruct = this.state.argsBuscEstruct
              this.setState({argsBuscEstruct});
              this.handleBuscEstruct(argsBuscEstruct)

              document.getElementById("img").value = ""
            }
          }

          let nombreDoc = file.name
          // let img = document.createElement("img");
          // img.src = URL.createObjectURL(file);
          // img.setAttribute( "name", nombreDoc );
          // img.onload = function() {

            let data=""
            // console.log(data)
            // console.log(img)
            updState(data, nombreDoc)
          // }
          //FIN PROCESO PARA GUARDAR LA IMAGEN EN LA BASE DE DATOS

        }else{
          console.log("No ingresado")
          if(ii===listImg.length-1){
            document.body.style.cursor = 'default'
            alert("!! Proceso finalizado !!")

            const argsBuscEstruct = this.state.argsBuscEstruct
            this.setState({argsBuscEstruct});
            this.handleBuscEstruct(argsBuscEstruct)

            document.getElementById("img").value = ""
          }

        }
      }
    }else{
      alert("!! Por favor seleccione el equipo !!")
      // document.getElementById("img").value = ""
    }
  }

  handleElimAsDocEq = async (ev, idListaP)=>{
// console.log("Eliminar", idListaP)

    if(idListaP.descrEquipo){
      //VALIDAR SI EL ARCHIVO ESTA ASOCIADO VARIAS VECES => NO SE COPIA
      let argsBuscar = {}
      argsBuscar = `'descrEmpresa': '${idListaP.descrEmpresa}', 'nombreDoc': '${idListaP.nombreDoc}'`
      let argsBuscarPl = {}
      let argsQuery = `{"$unwind": "$secciones"},
        {"$unwind": "$secciones.equipos"},
        {"$unwind": "$secciones.equipos.documentos"},
        {$project: {idPlanta: '$_id', descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
          descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
          descrEquipo: '$secciones.equipos.descrEquipo', nombreDoc: '$secciones.equipos.documentos.nombreDoc'}}`
      argsBuscarPl = {tipoqry: `[${argsQuery}, {$match: {${argsBuscar}}}]`}
      // console.log(argsBuscarPl)
      let regExisteArch = []

      if(this.props.allPlantaRtes1.allPlantaRtes){
        let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
        // console.log(this.props.allPlantaRtes1.allPlantaRtes.length)
        regExisteArch = await data.allPlantaRtes
      }
      // console.log(regExisteArch)
      let descrComponenteAnt = ""
      if(regExisteArch.length===1){
        //Esta asociado una sola vez => se puede eliminar de la carpeta
        // descrComponenteAnt = idListaP.descrEmpresa.replace(/^\s+|\s+/g, '') //quitar espacios
        descrComponenteAnt = idListaP.descrEmpresa.replace(/\./g,'') //quitar puntos
        // descrComponenteAnt = idListaP.descrEmpresa
      }
      const argsUpd = {
        descrEmpresa: idListaP.descrEmpresa,
        descrPlanta: idListaP.descrPlanta,
        descrSeccion: idListaP.descrSeccion,
        descrEquipo: idListaP.descrEquipo,
        nombreDoc: idListaP.nombreDoc,
        descrComponenteAnt: descrComponenteAnt
      }
      argsUpd.tipoAct = "EliminarDoc"
      // console.log(argsUpd)
      await this.props.editPlantaUpdSeccion({variables: argsUpd});

      const argsBuscEstruct = this.state.argsBuscEstruct
      this.setState({argsBuscEstruct});
      this.handleBuscEstruct(argsBuscEstruct)
    }else{
      alert("!! Por favor seleccione el equipo !!")
    }
  }


  handleCicloFactCl = () => {
    var miLista = document.getElementById("miListaCF");
    const argsAdd = this.state.argsAdd
    argsAdd['cicloFact'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleTipoDocCl = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['_idTipoDoc'] = miLista.options[miLista.selectedIndex].value
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsAdd['codigoTipoDoc'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['descrTipoDoc'] = miLista.options[miLista.selectedIndex].attributes[1].value
    }else{
      argsAdd['descrTipoDoc'] = "Seleccionar..."
    }
    this.setState({argsAdd});
  }

  handleSelEmp = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['descrEmpresa'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSelLoc = () => {
    var miLista = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['descrLocalizac'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleTipoClCl = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    // console.log(argsAdd)
    argsAdd['_idTipoCl'] = miLista.options[miLista.selectedIndex].value
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsAdd['codigoTipoCliente'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['descrTipoCliente'] = miLista.options[miLista.selectedIndex].attributes[1].value
    }else{
      argsAdd['descrTipoCliente'] = "Seleccionar..."
    }
    // console.log(argsAdd)
    this.setState({argsAdd});
  }

  handleGrAfCl = () => {
    var miLista = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['_idGrupoAf'] = miLista.options[miLista.selectedIndex].value
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsAdd['codigoGrupoAfin'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['descrGrupoAfin'] = miLista.options[miLista.selectedIndex].attributes[1].value
    }else{
      argsAdd['descrGrupoAfin'] = "Seleccionar..."
    }
    this.setState({argsAdd});
  }

  handleEstrCl = () => {
    var miLista = document.getElementById("miLista3");
    const argsAdd = this.state.argsAdd
    argsAdd['descrEstrato'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handlePerfilUsuario = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['descrPerfil'] = miLista.options[miLista.selectedIndex].text
    argsAdd['_id'] = miLista.options[miLista.selectedIndex].value
    this.setState({argsAdd});
  }

  idLista = async (ev, idLista)=>{
    this.setState({idLista: idLista})
    ev.preventDefault()
    this.estadosFalse()
    if (this.state.showEstructura) {
      this.setState({verEstructura: true})
    }
  };

  handleClickUpd = (ev) => {
    ev.preventDefault()
    this.setState({
      permiteMovFinanc: false,
      permiteHistEgreso: false,
      permiteHistIngreso: false,
      permiteUpdate: true,
      permiteDelete: false,
    })
  }

  handleClickDel = (ev) => {
    ev.preventDefault()
    this.setState({
      permiteMovFinanc: false,
      permiteHistEgreso: false,
      permiteHistIngreso: false,
      permiteUpdate: false,
      permiteDelete: true,
    })
  }

  showDescFormato = async () => {
    const ExcelJS = require('exceljs');
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Formato');

    const headers = ['Consecutivo', 'Empresa', 'Planta', 'Código planta', 'Sección', 'Código sección', 'Equipo', 'Código de equipo', 
         'Num carta equipo', 'Programa', 'Componente', 'Código de Componente', 'Mecanismo', 'Código de mecanismo', 'Tipo de mecanismo', 
         'Aplicación', 'Nombre del lubricante', 'Cantidad total de lubricante', 'Cantidad de lubricante Por Tarea', 'Unidad', 'Puntos a lubricar', 
         'Minutos de ejec. de tarea', 'Método de lubricación', 'Tarea de lubricación', 'Modo ejec. Tarea (I/O)', 'Requiere SISO', 
         'Tipo frecuencia', 'Frecuencia', 'Frecuencia Predictiva', 'Año prox.', 'Mes prox.', 'Día prox.', 'Acum. Prox.', 'Codigo del Procedimiento', 'Advertencia en tarea'];
    worksheet.addRow(headers);

    const programas = ['Sin programa'];
    const modos = ['I', 'O'];
    const siso = ['Si', 'No'];
    const tipos = ['Calendario', 'Horas', 'Km'];

    const allEmpresa = this.props.allEmpresa.allEmpresa.map((empresa) => empresa.descrEmpresa)
    allEmpresa.forEach((valor, index) => {
      worksheet.getCell(`CK${index + 1}`).value = valor;
    });    
    const allUtilidad = this.props.allUtilidad.allUtilidad.map((utilidad) => utilidad.descrUtilidad)
    allUtilidad.forEach((valor, index) => {
      worksheet.getCell(`CC${index + 1}`).value = valor;
    });
    const allAplicacion = this.props.allAplicacion.allAplicacion.map((aplicacion) => aplicacion.descrAplicacion)
    allAplicacion.forEach((valor, index) => {
      worksheet.getCell(`CD${index + 1}`).value = valor;
    });
    const allUnidad = ['Gal', 'lt', 'ml', 'kg', 'Lb', 'gr', 'oz']
    allUnidad.forEach((valor, index) => {
      worksheet.getCell(`CE${index + 1}`).value = valor;
    });
    const allMetodo = this.props.allMetodo.allMetodo.map((metodo) => metodo.descrMetodo)
    allMetodo.forEach((valor, index) => {
      worksheet.getCell(`CF${index + 1}`).value = valor;
    });
    const allTarea = this.props.allTarea.allTarea.map((tarea) => tarea.descrTarea)
    allTarea.forEach((valor, index) => {
      worksheet.getCell(`CG${index + 1}`).value = valor;
    });
    const allFrecuencia = this.props.allFrecuencia.allFrecuencia.map((frecuencia) => frecuencia.descrFrecuencia)
    allFrecuencia.forEach((valor, index) => {
      worksheet.getCell(`CH${index + 1}`).value = valor;
    });
    const allProcEjec = this.props.allProcEjec.allProcEjec.map((proceso) => proceso.codProcedimiento)
    allProcEjec.forEach((valor, index) => {
      worksheet.getCell(`CI${index + 1}`).value = valor;
    });
    const allLubricante = this.props.allLubricante.allLubricante.map((lubricante) => lubricante.descrLubricante)
    allLubricante.forEach((valor, index) => {
      worksheet.getCell(`CJ${index + 1}`).value = valor;
    });
    // const allInfoTarea = []
    // if(this.props.allInfoTarea.allInfoTarea){
      const allInfoTarea = this.props.allInfoTarea.allInfoTarea.map((info) => info.codInfoTarea)
      allInfoTarea.forEach((valor, index) => {
        worksheet.getCell(`CL${index + 1}`).value = valor;
      });
    // }

    for (let i = 2; i <= 5000; i++) { 
      worksheet.getCell(`J${i}`).dataValidation = {
        type: 'list',
        allowBlank: false,
        formulae: [`"${programas.join(',')}"`],
        showErrorMessage: true, // Muestra un mensaje de error
        errorStyle: 'stop', // Detiene la entrada de datos no válida
        errorTitle: 'Valor no válido',
        error: 'Por favor, selecciona un valor de la lista.',
      };
      worksheet.getCell(`Y${i}`).dataValidation = {
        type: 'list',
        allowBlank: false,
        formulae: [`"${modos.join(',')}"`],
        showErrorMessage: true, // Muestra un mensaje de error
        errorStyle: 'stop', // Detiene la entrada de datos no válida
        errorTitle: 'Valor no válido',
        error: 'Por favor, selecciona un valor de la lista.',
      };
      worksheet.getCell(`Z${i}`).dataValidation = {
        type: 'list',
        allowBlank: false,
        formulae: [`"${siso.join(',')}"`],
        showErrorMessage: true, // Muestra un mensaje de error
        errorStyle: 'stop', // Detiene la entrada de datos no válida
        errorTitle: 'Valor no válido',
        error: 'Por favor, selecciona un valor de la lista.',
      };
      worksheet.getCell(`AA${i}`).dataValidation = {
        type: 'list',
        allowBlank: false,
        formulae: [`"${tipos.join(',')}"`],
        showErrorMessage: true, // Muestra un mensaje de error
        errorStyle: 'stop', // Detiene la entrada de datos no válida
        errorTitle: 'Valor no válido',
        error: 'Por favor, selecciona un valor de la lista.',
      };
      worksheet.getCell(`B${i}`).dataValidation = {
        type: 'list',
        allowBlank: false,
        formulae: [`CK$1:CK$${allEmpresa.length}`],
        showErrorMessage: true, // Muestra un mensaje de error
        errorStyle: 'stop', // Detiene la entrada de datos no válida
        errorTitle: 'Valor no válido',
        error: 'Por favor, selecciona un valor de la lista.',
      };
      worksheet.getCell(`O${i}`).dataValidation = {
        type: 'list',
        allowBlank: false,
        formulae: [`CC$1:CC$${allUtilidad.length}`],
        showErrorMessage: true, // Muestra un mensaje de error
        errorStyle: 'stop', // Detiene la entrada de datos no válida
        errorTitle: 'Valor no válido',
        error: 'Por favor, selecciona un valor de la lista.',
      };
      worksheet.getCell(`P${i}`).dataValidation = {
        type: 'list',
        allowBlank: false,
        formulae: [`CD$1:CD$${allAplicacion.length}`],
        showErrorMessage: true, // Muestra un mensaje de error
        errorStyle: 'stop', // Detiene la entrada de datos no válida
        errorTitle: 'Valor no válido',
        error: 'Por favor, selecciona un valor de la lista.',
      };
      worksheet.getCell(`T${i}`).dataValidation = {
        type: 'list',
        allowBlank: false,
        formulae: [`CE$1:CE$${allUnidad.length}`],
        showErrorMessage: true, // Muestra un mensaje de error
        errorStyle: 'stop', // Detiene la entrada de datos no válida
        errorTitle: 'Valor no válido',
        error: 'Por favor, selecciona un valor de la lista.',
      };
      worksheet.getCell(`W${i}`).dataValidation = {
        type: 'list',
        allowBlank: false,
        formulae: [`CF$1:CF$${allMetodo.length}`],
        showErrorMessage: true, // Muestra un mensaje de error
        errorStyle: 'stop', // Detiene la entrada de datos no válida
        errorTitle: 'Valor no válido',
        error: 'Por favor, selecciona un valor de la lista.',
      };
      worksheet.getCell(`X${i}`).dataValidation = {
        type: 'list',
        allowBlank: false,
        formulae: [`CG$1:CG$${allTarea.length}`],
        showErrorMessage: true, // Muestra un mensaje de error
        errorStyle: 'stop', // Detiene la entrada de datos no válida
        errorTitle: 'Valor no válido',
        error: 'Por favor, selecciona un valor de la lista.',
      };
      worksheet.getCell(`AB${i}`).dataValidation = {
        type: 'list',
        allowBlank: false,
        formulae: [`CH$1:CH$${allFrecuencia.length}`],
        showErrorMessage: true, // Muestra un mensaje de error
        errorStyle: 'stop', // Detiene la entrada de datos no válida
        errorTitle: 'Valor no válido',
        error: 'Por favor, selecciona un valor de la lista.',
      };
      worksheet.getCell(`AC${i}`).dataValidation = {
        type: 'list',
        allowBlank: false,
        formulae: [`CH$1:CH$${allFrecuencia.length}`],
        showErrorMessage: true, // Muestra un mensaje de error
        errorStyle: 'stop', // Detiene la entrada de datos no válida
        errorTitle: 'Valor no válido',
        error: 'Por favor, selecciona un valor de la lista.',
      };
      worksheet.getCell(`AH${i}`).dataValidation = {
        type: 'list',
        allowBlank: false,
        formulae: [`CI$1:CI$${allProcEjec.length}`],
        showErrorMessage: true, // Muestra un mensaje de error
        errorStyle: 'stop', // Detiene la entrada de datos no válida
        errorTitle: 'Valor no válido',
        error: 'Por favor, selecciona un valor de la lista.',
      };
      worksheet.getCell(`Q${i}`).dataValidation = {
        type: 'list',
        allowBlank: false,
        formulae: [`CJ$1:CJ$${allLubricante.length}`],
        showErrorMessage: true, // Muestra un mensaje de error
        errorStyle: 'stop', // Detiene la entrada de datos no válida
        errorTitle: 'Valor no válido',
        error: 'Por favor, selecciona un valor de la lista.',
      };    
      // if(allInfoTarea.length>0){
        worksheet.getCell(`AI${i}`).dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`CL$1:CL$${allInfoTarea.length}`],
          showErrorMessage: true, // Muestra un mensaje de error
          errorStyle: 'stop', // Detiene la entrada de datos no válida
          errorTitle: 'Valor no válido',
          error: 'Por favor, selecciona un valor de la lista.',
        };
      // }
    }

    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Formato_cargue_Masivo.xlsx';
    a.click();
    URL.revokeObjectURL(url);
  }

showDescEstruct = async () => {
  let argsBuscar=""
  argsBuscar += `'descrEmpresa': '${this.state.argsBuscEstruct.descrEmpresa}'`
  if(this.state.argsBuscEstruct.descrPlanta){
    argsBuscar += `, 'descrPlanta': /${this.state.argsBuscEstruct.descrPlanta}/i`
  }
  if(this.state.argsBuscEstruct.descrSeccion){
    argsBuscar += `, 'descrSeccion': /${this.state.argsBuscEstruct.descrSeccion}/i`
  }
  if(this.state.argsBuscEstruct.descrEquipo){
    argsBuscar += `, 'descrEquipo': /${this.state.argsBuscEstruct.descrEquipo}/i`
  }
  if(this.state.argsBuscEstruct.descrComponente){
    argsBuscar += `, 'descrComponente': /${this.state.argsBuscEstruct.descrComponente}/i`
  }
  if(this.state.argsBuscEstruct.descrMecanismo){
    argsBuscar += `, 'descrMecanismo': /${this.state.argsBuscEstruct.descrMecanismo}/i`
  }
  let argsBuscarPl = {}
  argsBuscarPl = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}

  console.log(argsBuscarPl)
  let {data} = await this.props.allPlantaRtes2.refetch(argsBuscarPl)
  let estructura = await data.allPlantaRtes
  console.log(estructura)

  if(estructura.length>0){
//Archivo Excel
    let xlsString = []
    let listRtes = estructura
// console.log(listRtes)
    let xlsString1 = []
    // xlsString1 = ['Consecutivo', 'Empresa', 'Planta', 'Codigo Planta', 'Sección', 'Codigo Sección', 'Equipo',
    //   'Código de Equipo', 'Componente', 'Código de Componente', 'Mecanismo', 'Código de Mecanismo',
    //   'Aplicación', 'Tipo de lubricante', 'Nombre del lubricante', 'Cantidad total de lubricante',
    //   'Cantidad de lubricante Por Tarea', 'Unidad', 'Puntos a lubricar', 'Minutos de ejec. de tarea', 'Método de lubricación',
    //   'Tarea de lubricación', 'Tipo frecuencia', 'Frecuencia', 'Frecuencia Predictiva',
    //   'Año prox. ejec.', 'Mes prox. ejec.', 'Día prox. ejec.', 'Acum. prox.', 'Codigo del Procedimiento'
    // ]
    xlsString1 = ['Empresa', 'Planta', 'Codigo Planta', 'Sección', 'Codigo Sección', 'Equipo',
      'Código de Equipo', 'Componente', 'Código de Componente', 'Mecanismo', 'Código de Mecanismo',
      'Tipo de mecanismo', 'Aplicación', 'Nombre del lubricante', 'Tipo frecuencia', 'Cantidad total de lubricante',
      'Unidad', 'CODIGO QR']    
    xlsString.push(xlsString1)

    for(let i=0; i<listRtes.length; i++){
      xlsString1 = [listRtes[i].descrEmpresa, listRtes[i].descrPlanta,
      listRtes[i].codPlanta, listRtes[i].descrSeccion, listRtes[i].codSeccion, listRtes[i].descrEquipo,
      listRtes[i].codEquipo, listRtes[i].descrComponente, listRtes[i].codComponente, listRtes[i].descrMecanismo,
      listRtes[i].codMecanismo, listRtes[i].descrUtilidad, listRtes[i].descrAplicacion, listRtes[i].descrLubricante, listRtes[i].tipoFrecuencia, 
      listRtes[i].cantidadTotal, listRtes[i].abrevUnidad, listRtes[i].codigoQR]
// console.log(xlsString1)
      xlsString.push(xlsString1)
    }
// console.log(xlsString)

    var wb = XLSX.utils.book_new();

    wb.Props = {
      Title: "SheetJS Tutorial",
      Subject: "Test",
      Author: "Red Stapler",
      CreatedDate: new Date(2017,12,19)
    };

    wb.SheetNames.push("Estructura");

    let ws_data = xlsString;

    let ws = XLSX.utils.aoa_to_sheet(ws_data);
    wb.Sheets["Estructura"] = ws;
    let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
    function s2ab(s) { 
      let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      let view = new Uint8Array(buf);  //create uint8array as viewer
      for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
      return buf;    
    }
    saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), this.state.argsBuscEstruct.descrEmpresa + '_estructura.xlsx');
  }
}

showDescPDFQR = async () => {
  var QRCode = require('qrcode');
  document.body.style.cursor = 'wait'

  let medidaQR = 2
  if(this.props.getParametro.getParametro){
    medidaQR = this.props.getParametro.getParametro.medidaQR
  }

  let argsBuscar=""
  // argsBuscar += `'descrEmpresa': '${this.state.argsBuscEstruct.descrEmpresa}'`
  argsBuscar += `'codComponente': {$ne: 'EXCLUIR'}, 'descrEmpresa': '${this.state.argsBuscEstruct.descrEmpresa}'`
  if(this.state.argsBuscEstruct.descrPlanta){
    argsBuscar += `, 'descrPlanta': /${this.state.argsBuscEstruct.descrPlanta}/i`
  }
  if(this.state.argsBuscEstruct.descrSeccion){
    argsBuscar += `, 'descrSeccion': /${this.state.argsBuscEstruct.descrSeccion}/i`
    // argsBuscar += `, 'descrSeccion': ${this.state.argsBuscEstruct.descrSeccion}`
  }
  if(this.state.argsBuscEstruct.descrEquipo){
    argsBuscar += `, 'descrEquipo': /${this.state.argsBuscEstruct.descrEquipo}/i`
  }
  if(this.state.argsBuscEstruct.descrComponente){
    argsBuscar += `, 'descrComponente': /${this.state.argsBuscEstruct.descrComponente}/i`
  }
  if(this.state.argsBuscEstruct.descrMecanismo){
    argsBuscar += `, 'descrMecanismo': /${this.state.argsBuscEstruct.descrMecanismo}/i`
  }


  // argsBuscar += `, 'codigoQR': {$nin: []}`




  let argsBuscarPl = {}
  argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}

  if(this.props.allPlantaRtes2){
    let {data} = await this.props.allPlantaRtes2.refetch(argsBuscarPl)
    let estructura = await data.allPlantaRtes

    if(estructura.length>0){
      let listRtes = estructura

      for(let i=0; i<listRtes.length; i++){
        console.log(listRtes[i].codigoQR)
        if(!listRtes[i].codigoQR || listRtes[i].codigoQR==='' || listRtes[i].codigoQR===null){
          let codigoQR = await this.nextVal('codigoQR')
          let cadenaQR = ''
          for(let i=1; i<11-codigoQR.toString().length; i++){
            cadenaQR += '0'
          }
          cadenaQR += codigoQR.toString()
          let argsUpdQR = {}, updColeccMec = []
          argsUpdQR['descrEmpresa'] = listRtes[i].descrEmpresa
          argsUpdQR['descrPlanta'] = listRtes[i].descrPlanta
          argsUpdQR['descrSeccion'] = listRtes[i].descrSeccion
          argsUpdQR['descrEquipo'] = listRtes[i].descrEquipo
          argsUpdQR['descrComponente'] = listRtes[i].descrComponente
          argsUpdQR['descrMecanismo'] = listRtes[i].descrMecanismo
          argsUpdQR['codigoQR'] = cadenaQR
          argsUpdQR['tipoAct'] = "EditarCodigoQR"
          updColeccMec.push(argsUpdQR)
          argsUpdQR = {}

          let numDocCRUD = 0
          let totDocCRUD = 1
          let argsCrud = []
          let crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.editPlantaUpdSeccion)
          }  

          argsCrud[numDocCRUD] = updColeccMec[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editPlantaUpdSeccion
          await this.updColecc(crudColecc, argsCrud, totDocCRUD)
        }
      }
    }
  }

  if(this.props.allPlantaRtes2){
    let {data} = await this.props.allPlantaRtes2.refetch(argsBuscarPl)
    let estructura = await data.allPlantaRtes

    if(estructura.length>0){
      let empresa =''
      let listRtes = estructura
      let columna = 1
      let linea = 1
      let posicX = 0
      let posicY = 0
      let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
      doc.setPage()

      for(let i=0; i<listRtes.length; i++){
        empresa = listRtes[i].descrEmpresa
        let canvas = document.createElement("canvas");
        QRCode.toCanvas(canvas, listRtes[i].codigoQR)

        if(medidaQR===4){
          if(columna===1){
            posicX=20
          }else{
            if(columna===2){
              posicX=78
            }else{
              posicX=136
            }
          }
          if(linea===1){
            posicY=20
          }else{
            posicY = 20 + ((63 * linea) - 63)
          }

          if(linea===1){
            posicY=20
          }else{
            posicY = 20 + ((63 * linea) - 63)
          }
        }else{
          if(columna===1){
            posicX=20
          }else{
            if(columna===2){
              posicX=45
            }else{
              if(columna===3){
                posicX=70
              }else{
                if(columna===4){
                  posicX=95
                }else{
                  if(columna===5){
                    posicX=120
                  }else{
                    if(columna===6){
                      posicX=145
                    }else{
                      posicX=170
                    }
                  }
                }
              }
            }
          }
          if(linea===1){
            posicY=20
          }else{
            posicY = 20 + ((30 * linea) - 30)
          }
        }

        let imgSource = canvas.toDataURL("image/svg");
        doc.addImage(imgSource, 'svg', posicX, posicY, 24, 24);
        columna+=1
        
        if(medidaQR===4){
          if(columna===4){
            columna = 1
            linea+=1
            if(linea===5){
              linea=1
              doc.addPage()
            }
          }
        }else{
          if(columna===8){
            columna = 1
            linea+=1
            if(linea===9){
              linea=1
              doc.addPage()
            }
          }
        }
      }

      doc.save(empresa + '_Codigos_QR.pdf');
    }
  }
  document.body.style.cursor = 'default'

}


showDescEquipos = async () => {
  let argsBuscar=""
  argsBuscar += `'descrEmpresa': '${this.state.argsBuscEstruct.descrEmpresa}'`
  if(this.state.argsBuscEstruct.descrPlanta){
    argsBuscar += `, 'descrPlanta': /${this.state.argsBuscEstruct.descrPlanta}/i`
  }
  let argsBuscarPl = {}
  argsBuscarPl = {tipoqry: `[${this.state.argsQuery2}, {$match: {${argsBuscar}}}]`}


  let {data} = await this.props.allPlantaRtes2.refetch(argsBuscarPl)
  let estructura = await data.allPlantaRtes
  // console.log(estructura)

  if(estructura.length>0){
//Archivo Excel
    let xlsString = []
    let listRtes = estructura
    let xlsString1 = []
    xlsString1 = ['Empresa', 'Planta', 'Sección', 'Equipo', 'Operario', 'Num. carta', 'Programa equipo',
      'Imagen', 'Orden de imagen']
    xlsString.push(xlsString1)
    let empresa = ''

    for(let i=0; i<listRtes.length; i++){
      xlsString1 = [listRtes[i].descrEmpresa, listRtes[i].descrPlanta,
      listRtes[i].descrSeccion, listRtes[i].descrEquipo, listRtes[i].cedula,
      listRtes[i].numCarta, listRtes[i].descrPrograma?listRtes[i].descrPrograma:'Sin programa', listRtes[i].nombreImagen, listRtes[i].ordenImagen]

      xlsString.push(xlsString1)
      empresa = listRtes[i].descrEmpresa
    }

    var wb = XLSX.utils.book_new();

    wb.Props = {
      Title: "SheetJS Tutorial",
      Subject: "Test",
      Author: "Red Stapler",
      CreatedDate: new Date(2017,12,19)
    };

    wb.SheetNames.push("Equipos");

    let ws_data = xlsString;

    let ws = XLSX.utils.aoa_to_sheet(ws_data);
    wb.Sheets["Equipos"] = ws;
    let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
    function s2ab(s) { 
      let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      let view = new Uint8Array(buf);  //create uint8array as viewer
      for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
      return buf;    
    }
    saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}),empresa + '_Orden_Equipos.xlsx');
  }
}

showDescEquiposAcum = async () => {
  let argsBuscar=""
  argsBuscar += `'descrEmpresa': '${this.state.argsBuscEstruct.descrEmpresa}'`
  if(this.state.argsBuscEstruct.descrPlanta){
    argsBuscar += `, 'descrPlanta': /${this.state.argsBuscEstruct.descrPlanta}/i`
  }
  let argsBuscarPl = {}
  argsBuscarPl = {tipoqry: `[${this.state.argsQuery4}, {$match: {${argsBuscar}}}]`}


  let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
  let estructura = await data.allPlantaRtes
  // console.log(estructura)

  if(estructura.length>0){
//Archivo Excel
    let empresa = ''
    let xlsString = []
    let listRtes = estructura
    let xlsString1 = []
    xlsString1 = ['Empresa', 'Planta', 'Sección', 'Equipo', 'Acumulado', 'Horas/Km', 'Cant. por día']
    xlsString.push(xlsString1)

    for(let i=0; i<listRtes.length; i++){
      empresa = listRtes[i].descrEmpresa
      xlsString1 = [listRtes[i].descrEmpresa, listRtes[i].descrPlanta,
      listRtes[i].descrSeccion, listRtes[i].descrEquipo, listRtes[i].acumulado, listRtes[i].tipoFrecuencia, listRtes[i].horasKmPorDia]

      xlsString.push(xlsString1)
    }

    var wb = XLSX.utils.book_new();

    wb.Props = {
      Title: "SheetJS Tutorial",
      Subject: "Test",
      Author: "Red Stapler",
      CreatedDate: new Date(2017,12,19)
    };

    wb.SheetNames.push("Equipos");

    let ws_data = xlsString;

    let ws = XLSX.utils.aoa_to_sheet(ws_data);
    wb.Sheets["Equipos"] = ws;
    let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
    function s2ab(s) { 
      let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      let view = new Uint8Array(buf);  //create uint8array as viewer
      for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
      return buf;    
    }
    saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), empresa + '_Acumulados_Equipos.xlsx');
  }
}

  componentDidUpdate(prevProps, prevState){
    // console.log(this.state.argsBuscEstruct.descrEmpresa)
    if(this.state.argsBuscEstruct.descrEmpresa){
//Para actualizar los criterios de busqueda cuando se hace cambia de pantalla y regresa
      if(this.state.argsBuscEstruct.descrEmpresa){
        var descrEmpresa = document.getElementById("miLista");
        if(descrEmpresa){descrEmpresa.value = this.state.argsBuscEstruct.descrEmpresa}
      }

      if(this.state.argsBuscEstruct.numDocum){
        var numDocum = document.getElementById("numDocum");
        if(numDocum){numDocum.value = this.state.argsBuscEstruct.numDocum}
      }

      if(this.state.argsBuscEstruct.descrPlanta){
        var descrPlanta = document.getElementById("descrPlantaB");
        if(descrPlanta){descrPlanta.value = this.state.argsBuscEstruct.descrPlanta}
      }
      if(this.state.argsBuscEstruct.descrSeccion){
        var descrSeccion = document.getElementById("descrSeccionB");
        if(descrSeccion){descrSeccion.value = this.state.argsBuscEstruct.descrSeccion}
      }
      if(this.state.argsBuscEstruct.descrEquipo){
        var descrEquipo = document.getElementById("descrEquipoB");
        if(descrEquipo){descrEquipo.value = this.state.argsBuscEstruct.descrEquipo}
      }
      if(this.state.argsBuscEstruct.descrComponente){
        var descrComponente = document.getElementById("descrComponenteB");
        if(descrComponente){descrComponente.value = this.state.argsBuscEstruct.descrComponente}
      }
      if(this.state.argsBuscEstruct.descrMecanismo){
        var descrMecanismo = document.getElementById("descrMecanismoB");
        if(descrMecanismo){descrMecanismo.value = this.state.argsBuscEstruct.descrMecanismo}
      }
      if(this.state.argsBuscEstruct.estado){
        var estado = document.getElementById("estadoB");
        if(estado){descrMecanismo.value = this.state.argsBuscEstruct.estado}
      }
      this.props.allPlantaRtes.refetch()
//FIN Para actualizar los criterios de busqueda cuando se hace cambia de pantalla y regresa
    }

    if(this.state.showAsDocEq!==prevState.showAsDocEq&&prevState.showAsDocEq){
      let argsBuscEstruct = this.state.argsBuscEstruct
      // argsBuscEstruct.descrEmpresa = localStorage.getItem('Empresa')==="Todas..."?"Seleccionar Empresa...":localStorage.getItem('Empresa')
      argsBuscEstruct.descrEmpresa = "Seleccionar Empresa..."
      if(argsBuscEstruct.descrPlanta){
        delete argsBuscEstruct.descrPlanta
      }
      if(argsBuscEstruct.descrSeccion){
        delete argsBuscEstruct.descrSeccion
      }
      if(argsBuscEstruct.descrEquipo){
        delete argsBuscEstruct.descrEquipo
      }
    }

    if((this.state.argsBuscEstruct!==prevState.argsBuscEstruct)||
        (this.props.allPlantaRtes.allPlantaRtes&&this.props.allPlantaRtes.allPlantaRtes.length===0)||
        (this.state.showAsDocEq!==prevState.showAsDocEq)){
      let argsBuscar=""
      argsBuscar += `'descrEmpresa': '${this.state.argsBuscEstruct.descrEmpresa}'`
      if(this.state.argsBuscEstruct.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${this.state.argsBuscEstruct.descrPlanta}/i`
      }
      if(this.state.argsBuscEstruct.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${this.state.argsBuscEstruct.descrSeccion}/i`
      }
      if(this.state.argsBuscEstruct.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${this.state.argsBuscEstruct.descrEquipo}/i`
      }
      if(this.state.argsBuscEstruct.descrComponente){
        argsBuscar += `, 'descrComponente': /${this.state.argsBuscEstruct.descrComponente}/i`
      }
      if(this.state.argsBuscEstruct.descrMecanismo){
        argsBuscar += `, 'descrMecanismo': /${this.state.argsBuscEstruct.descrMecanismo}/i`
      }
      if(this.state.argsBuscEstruct.estado){
        argsBuscar += `, 'estado': /${this.state.argsBuscEstruct.estado}/i`
      }
      let argsBuscarPl = {}
      let argsQuery = this.state.argsQuery
      if(this.state.showAsDocEq){
        argsQuery = this.state.argsQuery3
      }      
      if(this.state.argsBuscEstruct.numDocum){
        argsBuscarPl = {tipoqry: `[${argsQuery}, {$match: {${argsBuscar}}}, {$limit: ${this.state.argsBuscEstruct.numDocum}}]`}
      }else{
        argsBuscarPl = {tipoqry: `[${argsQuery}, {$match: {${argsBuscar}}}, {$limit: 100}]`}
      }
      console.log()
      this.props.allPlantaRtes.refetch(argsBuscarPl)

      // this.setState({argsBuscEstruct: this.state.argsBuscEstruct})
    }
  }

  render(){
    const {showEstructura, 
          showUser, showConfig, showGer, showSimula, showAddEstruct, showUpdEstruct, showUpdEq, showUpdEqAc,
          showCar, showLab, showProg, addEstructura, verEstructura, showAdmin, showIndEmp, showBitaEmp, 
          permiteMovFinanc, permiteHistEgreso, permiteHistIngreso,
          permiteUpdate, permiteDelete, argsAdd, errorAdd, idLista, showAsDocEq,
          argsBuscEstruct, argsQuery} = this.state;

// console.log(localStorage.getItem('userLogin'))
// console.log(localStorage.getItem('token'))
// console.log(localStorage.getItem('Ciudad'))
// console.log(showEstructura, verEstructura)
    let autorizacUA = [], descrEmpresaUA=localStorage.getItem('Empresa'), versionMacroUA=0
    let matchEmpresa = "", nomUsuarioUA = ""
    if(localStorage.getItem('userLogin')==="slcm@slcm.com"){
      descrEmpresaUA = "Todas..."
      versionMacroUA = 1
      if(this.props.allAutorizac.allAutorizac){
        autorizacUA = this.props.allAutorizac.allAutorizac.map(autorizac => autorizac.codigoAutorizac)
      }
    }else{
      if(this.props.allUsuarios.allUsuarios){
        if(this.props.allPerfiles.allPerfiles){
          const usuActivo = this.props.allUsuarios.allUsuarios.filter(usuario => usuario.email===localStorage.getItem('userLogin'))
          if(usuActivo[0]){
            descrEmpresaUA = usuActivo[0].descrEmpresa
            versionMacroUA = usuActivo[0].versionMacro
            nomUsuarioUA = usuActivo[0].nombreUsuario
            const perfilUA = this.props.allPerfiles.allPerfiles.filter(perfil => perfil._id===usuActivo[0].perfil._id)
            autorizacUA = perfilUA[0].autorizac.map((elemento, _id) => elemento.codigoAutorizac)
          }
        }
      }
    }
// console.log(versionMacroUA)
    const a01 = autorizacUA.findIndex( autorizac => autorizac === "01" );
    const a05 = autorizacUA.findIndex( autorizac => autorizac === "05" );
    const a10 = autorizacUA.findIndex( autorizac => autorizac === "10" );
    // const a12 = autorizacUA.findIndex( autorizac => autorizac === "12" );
    const a15 = autorizacUA.findIndex( autorizac => autorizac === "15" );
    const a20 = autorizacUA.findIndex( autorizac => autorizac === "20" );
    const a25 = autorizacUA.findIndex( autorizac => autorizac === "25" );
    const a30 = autorizacUA.findIndex( autorizac => autorizac === "30" );
    const a35 = autorizacUA.findIndex( autorizac => autorizac === "35" );
    const a40 = autorizacUA.findIndex( autorizac => autorizac === "40" );

    let lista = []
    let lista1 = []
    let lista10 = []
    let lista11 = [], listaE = []

    if (this.state.showEstructura) {
      if(this.props.allPlantaRtes.allPlantaRtes){lista = this.props.allPlantaRtes.allPlantaRtes}
      lista1.push({descrEmpresa: "Seleccionar Empresa...", _id: 0})
      if(descrEmpresaUA==="Todas..."){
        if(this.props.allEmpresa.allEmpresa){
          this.props.allEmpresa.allEmpresa.forEach((elemento, ii) => {
            lista1.push({descrEmpresa: elemento.descrEmpresa, _id: ii+1})
          })
        }
      }else{
        lista1.push({descrEmpresa: descrEmpresaUA, _id: 1})
      } 

    }

    if (this.state.addEstructura || this.state.verEstructura) {
      if(this.props.allLubricante.allLubricante){lista = this.props.allLubricante.allLubricante}
      if(this.props.allAplicacion.allAplicacion){lista10 = this.props.allAplicacion.allAplicacion}
      if(this.props.allUnidad.allUnidad){lista11 = this.props.allUnidad.allUnidad}
      if(this.props.allEmpresa.allEmpresa){lista1 = this.props.allEmpresa.allEmpresa}
    }
    if (this.state.showIndEmp || this.state.showBitaEmp) {
      if(this.props.allEmpresa.allEmpresa){listaE = this.props.allEmpresa.allEmpresa}
    }
    if (this.state.showAsDocEq) {
      if(this.props.allPlantaRtes.allPlantaRtes){lista = this.props.allPlantaRtes.allPlantaRtes}
      // lista1.push({descrEmpresa: "Seleccionar Empresa...", logo: "", _id: 0})
      if(this.props.allEmpresa.allEmpresa){
        this.props.allEmpresa.allEmpresa.forEach((elemento, ii) => {
          if(descrEmpresaUA==="Todas..."){
            lista1.push({descrEmpresa: elemento.descrEmpresa, logo: elemento.logo, _id: ii+1})
          }else{
            if(descrEmpresaUA===elemento.descrEmpresa){
              lista1.push({descrEmpresa: elemento.descrEmpresa, logo: elemento.logo, _id: ii+1})
            }
          }
        })
      }
    }

     let mensaje = ""
     let rutaLogo=""
     let empresa = {empresaRazonSocial: "", empresaNit: "", empresaDir: "", empresaTel: ""}
     if(this.props.getParametro.getParametro){
      mensaje = this.props.getParametro.getParametro.mensaje
      empresa.empresaRazonSocial = this.props.getParametro.getParametro.empresaRazonSocial
      empresa.empresaNit = this.props.getParametro.getParametro.empresaNit
      empresa.empresaDir = this.props.getParametro.getParametro.empresaDir
      empresa.empresaTel = this.props.getParametro.getParametro.empresaTel
      rutaLogo = this.props.getParametro.getParametro.rutaLogo
     }

    if(descrEmpresaUA==="Todas..."){
      matchEmpresa = `{$ne: 'Seleccionar...'}`
    }else{
      matchEmpresa = `'${descrEmpresaUA}'`
    }

     
    return (
      <div>
        <div className="ui two column stackable grid">
          <div className="row rowBotones container" style={styles.bordes}>

            <div className="column" style={styles.menuPpal}>
              <img src="images/LCMSAS.png" alt="Logo de LCM"
                    width="168"
                    height="62"
                    // left="200"
                    />

              {/* <svg height="55" width="250">
                <text x="70" y="42" fill="#c1b82f"  style={{font: '50px Calibri', fontWeight: 'Bold', fontStyle: 'Italic'}}>
                  slcm
                </text>
              </svg> */}
            </div>
            
            <div className="column" style={styles.boxDer}>
              <div className="ui labeled inverted icon menu" style={styles.menu}>
                {a01!==-1 &&
                <a href="" onClick={this.showEstructura} className="item selected">
                  <i className="industry yellow icon"></i>
                  Plantas
                </a>
                }
                {a05!==-1 &&
                <a href="" onClick={this.showCar} className="item">
                  <i className="tint yellow icon"></i>
                  Cartas de lubricación
                </a>
                }
                {a10!==-1 &&
                <a href="" onClick={this.showLab} className="item">
                  <i className="flask yellow icon"></i>
                  Laboratorio
                </a>
                }
                {a15!==-1 &&
                <a href="" onClick={this.showProg} className="item">
                  <i className="calendar alternate outline yellow icon"></i>
                  Programación
                </a>
                }
                {a30!==-1 &&
                <a href="" onClick={this.showSimula} className="item">
                  <i className="share alternate yellow icon"></i>
                  Simuladores
                </a>
                }
                {a35!==-1 &&
                <a href="" onClick={this.showAdmin} className="item">
                  <i className="sitemap yellow icon"></i>
                  Administrativo
                </a>
                }
                {a20!==-1 &&
                <a href="" onClick={this.showUser} className="item">
                  <i className="user circle yellow icon"></i>
                  Usuarios
                </a>
                }
                {a25!==-1 &&
                <a href="" onClick={this.showConfig} className="item">
                  <i className="settings yellow icon"></i>
                  Configurar
                </a>
                }
                {a40!==-1 &&
                <a href="" onClick={this.showGer} className="item">
                  <i className="users yellow icon"></i>
                  Gerencia
                </a>
                }
                


                <a href="" onClick={this.logout} className="right item">
                  <i className="close yellow icon"></i>
                  Salir
                </a>
              </div>
            </div>
          </div>
          
          <div className="row" style={styles.rowMarquee}>
            {/* <marquee behavior="alternate" scrollamount="7" color="red">!! Mensaje !!</marquee> */}
            <div className="marquee" width="50%">
              <div>
                {/* <span>!! El sacrificio de hoy es el éxito de mañana !!</span>
                <span>!! El sacrificio de hoy es el éxito de mañana !!</span> */}
                <span>{mensaje}</span>
                <span>{mensaje}</span>                
              </div>
            </div>
          </div>

          {(!showCar && !showLab && !showProg && !showConfig && !showUser && !showSimula && !showAdmin && !showGer) &&
            <div className="column" style={styles.boxIzq}>  
              {showEstructura && <HomePr1 autorizacUA={autorizacUA} styles={styles}
                    handleClickSel1={this.showAddEstruct} handleClickSel4={this.showDescEquipos}
                    // handleClickSel2={this.showDescEstruct} handleClickSel3={this.showUpdEstruct} 
                    handleClickSel5={this.showUpdEq} handleClickSel6={this.showAsDocEq} 
                    handleClickSel7={this.showDescEquiposAcum} handleClickSel8={this.showUpdEqAc}
                    handleClickSel9={this.showDescEstruct} handleClickSel10={this.showUpdEstruct}
                    handleClickSel11={this.showDescPDFQR} handleClickSel12={this.showDescFormato}
                    handleClickSel2={this.showIndEmp} handleClickSel3={this.showBitaEmp}
                    handleChange={this.handleChangeBuscEstruct} handleSubmit={this.handleBuscEstruct}
                    args={argsBuscEstruct}/>}
              {addEstructura && <AddPr1 styles={styles} handleClickRegr={this.showEstructura}/>}
              {verEstructura && <VerPr1 autorizacUA={autorizacUA} styles={styles}
                    handleClickRegr={this.showEstructura}
                    handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

              {showAsDocEq && <AsocDocEq1 autorizacUA={this.props.autorizacUA} styles={styles}
                handleChange={this.handleChangeBuscEstruct} handleSubmit={this.handleBuscEstruct}
                args={argsBuscEstruct} handleClickRegr={this.showEstructura}/>}

              {showAddEstruct && <CargEst1 styles={styles} handleClickRegr={this.showEstructura}/>}
              {showUpdEstruct && <CargEst1 styles={styles} handleClickRegr={this.showEstructura}/>}
              {showUpdEq && <CargEst1 styles={styles} handleClickRegr={this.showEstructura}/>}
              {showUpdEqAc && <CargEst1 styles={styles} handleClickRegr={this.showEstructura}/>}
              {showIndEmp && <IndEmp1 styles={styles} handleClickRegr={this.showEstructura}/>}    
              {showBitaEmp && <BitaEmp1 styles={styles} handleClickRegr={this.showEstructura}/>}    
            </div>
          }
          {(!showCar && !showLab && !showProg && !showConfig && !showUser && !showSimula && !showAdmin&& !showGer) &&
            <div className="column" style={styles.boxDer}>
              {showEstructura && <HomePr2 autorizacUA={autorizacUA} styles={styles}
                  list={lista} list1={lista1} handleClickidLista={this.idLista}
                  handleChange={this.handleChangeBuscEstruct} argsBuscEstruct={argsBuscEstruct}/>}
              {addEstructura && <AddPr2 styles={styles} list={lista} list1={lista1}
                    handleSubmit={this.handlePlanta} handleChange={this.handleChange}
                    args={argsAdd} errors={errorAdd}  handleLista={this.handleTipoDocCl}
                    handleLista1={this.handleSelEmp} handleLista2={this.handleSelLoc}
                    handleLista3={this.handleEstrCl} handleLista4={this.handleCicloFactCl}/>}
              {verEstructura && <VerPr2 autorizacUA={autorizacUA} styles={styles} list={lista} list1={lista1}
                    list10={lista10} list11={lista11} errors={errorAdd} 
                    handleSubmit={this.handlePlanta} args={argsAdd} idLista={idLista}
                    permiteMovFinanc={permiteMovFinanc} permiteHistEgreso={permiteHistEgreso}
                    permiteHistIngreso={permiteHistIngreso}
                    permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}
                    empresa={empresa}/>}

              {showAsDocEq && <AsocDocEq2 autorizacUA={this.props.autorizacUA} styles={styles}
                  list={lista} list1={lista1} handleUpdAsDocEq={this.handleUpdAsDocEq}
                  handleElimAsDocEq={this.handleElimAsDocEq}
                  handleChange={this.handleChangeBuscEstruct}/>} 

              {showAddEstruct && <CargEst2 autorizacUA={autorizacUA} styles={styles} tipoCargue="Add"/>}
              {showUpdEstruct && <CargEst2 autorizacUA={autorizacUA} styles={styles} tipoCargue="Upd"/>}
              {showUpdEq && <CargEst2 autorizacUA={autorizacUA} styles={styles} tipoCargue="UpdEq"/>}
              {showUpdEqAc && <CargEst2 autorizacUA={autorizacUA} styles={styles} tipoCargue="UpdEqAc"/>}
              {showIndEmp && <IndEmp2 styles={this.props.styles} argsBuscEstruct={argsBuscEstruct} listaE={listaE}/>} 
              {showBitaEmp && <BitaEmp2 styles={this.props.styles} argsBuscEstruct={argsBuscEstruct} listaE={listaE}/>} 
            </div>
          }
          {showCar &&
            <div className="column" style={styles.boxUnaCol}>
              {showCar && <HomeCar autorizacUA={autorizacUA} 
                            descrEmpresaUA={descrEmpresaUA} styles={styles}
                            empresa={empresa}
                            rutaLogo={rutaLogo}/>}
            </div>
          }
          {showLab &&
            <div className="column" style={styles.boxUnaCol}>
              {showLab && <HomeLab usuario={localStorage.getItem('userLogin')} 
                            autorizacUA={autorizacUA} 
                            descrEmpresaUA={descrEmpresaUA} 
                            versionMacroUA={versionMacroUA} styles={styles}
                            empresa={empresa}
                            matchEmpresa={matchEmpresa}
                            rutaLogo={rutaLogo}/>}
            </div>
          }
          {showProg &&
            <div className="column" style={styles.boxUnaCol}>
              {showProg && <HomeProg autorizacUA={autorizacUA} 
                            descrEmpresaUA={descrEmpresaUA} styles={styles}
                            empresa={empresa}
                            rutaLogo={rutaLogo}/>} 
            </div> 
          }
          {showUser &&
            <div className="column" style={styles.boxUnaCol}>
              {showUser && <HomeUser autorizacUA={autorizacUA} styles={styles}/>}
            </div>
          }
          {showConfig &&
            <div className="column" style={styles.boxUnaCol}>
              {showConfig && <HomeConf autorizacUA={autorizacUA} styles={styles}/>}
            </div>
          }
          {showSimula &&
            <div className="column" style={styles.boxUnaCol}>
              {showSimula && <HomeSimu autorizacUA={autorizacUA} styles={styles}/>}
            </div>
          }
          {showAdmin &&
            <div className="column" style={styles.boxUnaCol}>
              {showAdmin && <HomeAdmin usuario={localStorage.getItem('userLogin')} 
              nomUsuarioUA={nomUsuarioUA}
              autorizacUA={autorizacUA} styles={styles}/>}
            </div>
          }
          {showGer &&
            <div className="column" style={styles.boxUnaCol}>
              {showGer && <HomeGer autorizacUA={autorizacUA} styles={styles}/>}
            </div>
          }
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}, {$limit : 100}]`}}}}),
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  
    graphql(queries.mutation.singleUpload, {name:'singleUpload'}),

  graphql(queries.query.allLubricante, {name:'allLubricante'}),
  graphql(queries.query.allAplicacion, {name:'allAplicacion'}),
  graphql(queries.query.allUnidad, {name:'allUnidad'}),
  graphql(queries.query.allUtilidad, {name:'allUtilidad'}),
  graphql(queries.query.allMetodo, {name:'allMetodo'}),
  graphql(queries.query.allTarea, {name:'allTarea'}),
  graphql(queries.query.allFrecuencia, {name:'allFrecuencia'}),
  graphql(queries.query.allProcEjec, {name:'allProcEjec'}),
  graphql(queries.query.allInfoTarea, {name:'allInfoTarea'}),
  graphql(queries.mutation.editPlanta, {name:'editPlanta'}),
  graphql(queries.mutation.editPlantaUpdSeccion, {name:'editPlantaUpdSeccion'}),
  graphql(queries.mutation.editPlantaEstructura, {name:'editPlantaEstructura'}),

  graphql(queries.mutation.deletePlanta, {name:'deletePlanta'}),

  graphql(queries.query.allGrado, {name:'allGrado'}),

  graphql(queries.query.allUsuarios, {name:'allUsuarios'}),

  graphql(queries.query.allPerfiles, {name:'allPerfiles', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allPerfilesRtes, {name:'allPerfilesRtes1',
  //   options: (props) => {return {variables: {tipoqry: `[{"$unwind": "$autorizac"},
  //   {$project: {_id: 1, descrPerfil: 1,
  //     codigoAutorizac: '$autorizac.codigoAutorizac'}}
  //   ]`}}}}),

  graphql(queries.mutation.createPerfil, {name:'createPerfil'}),
  graphql(queries.query.allAutorizac, {name:'allAutorizac', options: (props) => {return {variables: {}}}}),


  graphql(queries.query.getParametro, {name:'getParametro', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),
  graphql(queries.mutation.editSeqFrafindOneAndUpdate, {name:'editSeqFrafindOneAndUpdate'}),

  graphql(queries.mutation.encriptar, {name:'encriptar'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(Home)
